var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 57,
    viewBox: "0 0 134 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_120_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 15,
    width: 5,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.499 27.4555C21.499 31.3387 21.499 35.2219 21.499 39.1051C21.499 39.2215 21.5141 39.2236 21.3843 39.2236C20.1593 39.2236 18.9342 39.2236 17.7091 39.2236C17.7057 39.2236 17.703 39.2236 17.6995 39.2236C17.6313 39.2236 17.5972 39.1896 17.5972 39.1217C17.5972 35.1166 17.5972 31.1122 17.5972 27.1071C17.5972 27.0913 17.5972 27.0761 17.5972 27.0603C17.5958 27.0238 17.6158 27.0107 17.6494 27.0114C17.6652 27.0114 17.6803 27.0114 17.6961 27.0114C18.1782 27.0114 18.6602 27.0114 19.1416 27.0114C19.1539 27.0114 19.1663 27.0121 19.1787 27.0114C19.2206 27.0087 19.2446 27.0231 19.2398 27.0699C19.2384 27.0851 19.2398 27.1009 19.2398 27.1168C19.2398 30.5669 19.2398 34.017 19.2398 37.4672C19.2398 37.4768 19.2398 37.4857 19.2398 37.4954C19.2405 37.5876 19.2405 37.5883 19.3332 37.589C19.476 37.589 19.6195 37.589 19.7624 37.589C19.8461 37.589 19.8564 37.5773 19.8585 37.4906C19.8585 37.4747 19.8585 37.4596 19.8585 37.4437C19.8585 33.816 19.8585 30.1882 19.8585 26.5604C19.8585 26.378 19.8605 26.4055 19.7019 26.4055C19.04 26.4048 18.3773 26.4055 17.7153 26.4055C17.6995 26.4055 17.6844 26.4055 17.6686 26.4055C17.5986 26.4028 17.5986 26.4028 17.5972 26.3291C17.5972 26.3133 17.5972 26.2981 17.5972 26.2823C17.5972 23.5929 17.5972 20.9029 17.5972 18.2136C17.5972 18.1978 17.5979 18.1826 17.5972 18.1668C17.5938 18.1234 17.6116 18.1021 17.6563 18.1055C17.6686 18.1062 17.681 18.1055 17.6934 18.1055C18.1782 18.1055 18.6636 18.1055 19.1485 18.1055C19.2398 18.1055 19.2398 18.1055 19.2398 18.1991C19.2398 19.7325 19.2398 21.2658 19.2398 22.7991C19.2398 23.4132 19.2398 24.0267 19.2398 24.6409C19.2398 24.6505 19.2398 24.6595 19.2398 24.6691C19.2405 24.762 19.2405 24.7627 19.3332 24.7627C19.476 24.7627 19.6195 24.7627 19.7624 24.7627C19.8578 24.7627 19.8585 24.762 19.8585 24.6615C19.8585 24.6243 19.8585 24.5865 19.8585 24.5493C19.8585 21.6259 19.8585 18.7024 19.8585 15.779C19.8585 15.7728 19.8585 15.7666 19.8585 15.7604C19.8592 15.6792 19.8592 15.6785 19.9416 15.6785C20.4326 15.6764 20.9235 15.6764 21.4152 15.6764C21.4976 15.6764 21.4983 15.6771 21.499 15.7584C21.499 15.8017 21.499 15.8458 21.499 15.8892C21.499 19.7442 21.499 23.5998 21.499 27.4548V27.4555Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_120_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.514 15.6764H17.593V15.8045H21.514V15.6764Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 15.8045H17.5931V15.9325H21.5141V15.8045Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 15.9325H17.5931V16.0606H21.5141V15.9325Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 16.0606H17.5931V16.1887H21.5141V16.0606Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 16.1887H17.5931V16.3167H21.5141V16.1887Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 16.316H17.5931V16.4441H21.5141V16.316Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 16.4441H17.5931V16.5722H21.5141V16.4441Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 16.5722H17.5931V16.7002H21.5141V16.5722Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 16.7002H17.5931V16.8283H21.5141V16.7002Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 16.8283H17.5931V16.9564H21.5141V16.8283Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 16.9564H17.5931V17.0844H21.5141V16.9564Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 17.0844H17.5931V17.2125H21.5141V17.0844Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 17.2125H17.5931V17.3406H21.5141V17.2125Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 17.3399H17.5931V17.4679H21.5141V17.3399Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 17.4679H17.5931V17.596H21.5141V17.4679Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 17.596H17.5931V17.7241H21.5141V17.596Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 17.7241H17.5931V17.8521H21.5141V17.7241Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 17.8521H17.5931V17.9802H21.5141V17.8521Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 17.9802H17.5931V18.1083H21.5141V17.9802Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 18.1082H17.5931V18.2363H21.5141V18.1082Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 18.2356H17.5931V18.3637H21.5141V18.2356Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 18.3637H17.5931V18.4918H21.5141V18.3637Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 18.4918H17.5931V18.6198H21.5141V18.4918Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 18.6198H17.5931V18.7479H21.5141V18.6198Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 18.7479H17.5931V18.8759H21.5141V18.7479Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 18.8759H17.5931V19.004H21.5141V18.8759Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 19.004H17.5931V19.1321H21.5141V19.004Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 19.1321H17.5931V19.2601H21.5141V19.1321Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 19.2594H17.5931V19.3875H21.5141V19.2594Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 19.3875H17.5931V19.5156H21.5141V19.3875Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 19.5156H17.5931V19.6436H21.5141V19.5156Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 19.6436H17.5931V19.7717H21.5141V19.6436Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 19.7717H17.5931V19.8998H21.5141V19.7717Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 19.8998H17.5931V20.0278H21.5141V19.8998Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 20.0278H17.5931V20.1559H21.5141V20.0278Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 20.1559H17.5931V20.2839H21.5141V20.1559Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 20.2833H17.5931V20.4113H21.5141V20.2833Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 20.4113H17.5931V20.5394H21.5141V20.4113Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 20.5394H17.5931V20.6675H21.5141V20.5394Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 20.6674H17.5931V20.7955H21.5141V20.6674Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 20.7955H17.5931V20.9236H21.5141V20.7955Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 20.9236H17.5931V21.0516H21.5141V20.9236Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 21.0516H17.5931V21.1797H21.5141V21.0516Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 21.179H17.5931V21.3071H21.5141V21.179Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 21.3071H17.5931V21.4351H21.5141V21.3071Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 21.4351H17.5931V21.5632H21.5141V21.4351Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 21.5632H17.5931V21.6913H21.5141V21.5632Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 21.6913H17.5931V21.8193H21.5141V21.6913Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 21.8193H17.5931V21.9474H21.5141V21.8193Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 21.9474H17.5931V22.0755H21.5141V21.9474Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 22.0755H17.5931V22.2035H21.5141V22.0755Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 22.2028H17.5931V22.3309H21.5141V22.2028Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 22.3309H17.5931V22.459H21.5141V22.3309Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 22.459H17.5931V22.587H21.5141V22.459Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 22.587H17.5931V22.7151H21.5141V22.587Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 22.7151H17.5931V22.8432H21.5141V22.7151Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 22.8431H17.5931V22.9712H21.5141V22.8431Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 22.9712H17.5931V23.0993H21.5141V22.9712Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 23.0986H17.5931V23.2267H21.5141V23.0986Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 23.2267H17.5931V23.3547H21.5141V23.2267Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 23.3547H17.5931V23.4828H21.5141V23.3547Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 23.4828H17.5931V23.6108H21.5141V23.4828Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 23.6108H17.5931V23.7389H21.5141V23.6108Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 23.7389H17.5931V23.867H21.5141V23.7389Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 23.867H17.5931V23.995H21.5141V23.867Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 23.995H17.5931V24.1231H21.5141V23.995Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 24.1224H17.5931V24.2505H21.5141V24.1224Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 24.2505H17.5931V24.3785H21.5141V24.2505Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 24.3785H17.5931V24.5066H21.5141V24.3785Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 24.5066H17.5931V24.6347H21.5141V24.5066Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 24.6347H17.5931V24.7627H21.5141V24.6347Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 24.7627H17.5931V24.8908H21.5141V24.7627Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 24.8908H17.5931V25.0188H21.5141V24.8908Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 25.0189H17.5931V25.1469H21.5141V25.0189Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 25.1462H17.5931V25.2743H21.5141V25.1462Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 25.2743H17.5931V25.4023H21.5141V25.2743Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 25.4024H17.5931V25.5304H21.5141V25.4024Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 25.5304H17.5931V25.6585H21.5141V25.5304Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 25.6585H17.5931V25.7865H21.5141V25.6585Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 25.7865H17.5931V25.9146H21.5141V25.7865Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 25.9146H17.5931V26.0427H21.5141V25.9146Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 26.042H17.5931V26.17H21.5141V26.042Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 26.17H17.5931V26.2981H21.5141V26.17Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 26.2981H17.5931V26.4262H21.5141V26.2981Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 26.4262H17.5931V26.5542H21.5141V26.4262Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 26.5542H17.5931V26.6823H21.5141V26.5542Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 26.6823H17.5931V26.8104H21.5141V26.6823Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 26.8104H17.5931V26.9384H21.5141V26.8104Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 26.9384H17.5931V27.0665H21.5141V26.9384Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 27.0658H17.5931V27.1939H21.5141V27.0658Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 27.1939H17.5931V27.3219H21.5141V27.1939Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 27.3219H17.5931V27.45H21.5141V27.3219Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 27.45H17.5931V27.578H21.5141V27.45Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 27.578H17.5931V27.7061H21.5141V27.578Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 27.7061H17.5931V27.8342H21.5141V27.7061Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 27.8342H17.5931V27.9622H21.5141V27.8342Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 27.9615H17.5931V28.0896H21.5141V27.9615Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 28.0896H17.5931V28.2177H21.5141V28.0896Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 28.2177H17.5931V28.3457H21.5141V28.2177Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 28.3457H17.5931V28.4738H21.5141V28.3457Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 28.4738H17.5931V28.6019H21.5141V28.4738Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 28.6019H17.5931V28.7299H21.5141V28.6019Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 28.7299H17.5931V28.858H21.5141V28.7299Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 28.858H17.5931V28.9861H21.5141V28.858Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 28.9854H17.5931V29.1134H21.5141V28.9854Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 29.1134H17.5931V29.2415H21.5141V29.1134Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 29.2415H17.5931V29.3696H21.5141V29.2415Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 29.3696H17.5931V29.4976H21.5141V29.3696Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 29.4976H17.5931V29.6257H21.5141V29.4976Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 29.6257H17.5931V29.7538H21.5141V29.6257Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 29.7537H17.5931V29.8818H21.5141V29.7537Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 29.8818H17.5931V30.0099H21.5141V29.8818Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 30.0092H17.5931V30.1373H21.5141V30.0092Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 30.1372H17.5931V30.2653H21.5141V30.1372Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 30.2653H17.5931V30.3934H21.5141V30.2653Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 30.3934H17.5931V30.5214H21.5141V30.3934Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 30.5214H17.5931V30.6495H21.5141V30.5214Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 30.6495H17.5931V30.7776H21.5141V30.6495Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 30.7776H17.5931V30.9056H21.5141V30.7776Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 30.9049H17.5931V31.033H21.5141V30.9049Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 31.033H17.5931V31.1611H21.5141V31.033Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 31.1611H17.5931V31.2891H21.5141V31.1611Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 31.2891H17.5931V31.4172H21.5141V31.2891Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 31.4172H17.5931V31.5453H21.5141V31.4172Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 31.5452H17.5931V31.6733H21.5141V31.5452Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 31.6733H17.5931V31.8014H21.5141V31.6733Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 31.8014H17.5931V31.9294H21.5141V31.8014Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 31.9288H17.5931V32.0568H21.5141V31.9288Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 32.0568H17.5931V32.1849H21.5141V32.0568Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 32.1849H17.5931V32.3129H21.5141V32.1849Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 32.313H17.5931V32.441H21.5141V32.313Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 32.441H17.5931V32.5691H21.5141V32.441Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 32.5691H17.5931V32.6971H21.5141V32.5691Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 32.6971H17.5931V32.8252H21.5141V32.6971Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 32.8245H17.5931V32.9526H21.5141V32.8245Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 32.9526H17.5931V33.0806H21.5141V32.9526Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 33.0806H17.5931V33.2087H21.5141V33.0806Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 33.2087H17.5931V33.3368H21.5141V33.2087Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 33.3368H17.5931V33.4648H21.5141V33.3368Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 33.4648H17.5931V33.5929H21.5141V33.4648Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 33.5929H17.5931V33.721H21.5141V33.5929Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 33.7209H17.5931V33.849H21.5141V33.7209Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 33.8483H17.5931V33.9764H21.5141V33.8483Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 33.9764H17.5931V34.1045H21.5141V33.9764Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 34.1045H17.5931V34.2325H21.5141V34.1045Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 34.2325H17.5931V34.3606H21.5141V34.2325Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 34.3606H17.5931V34.4886H21.5141V34.3606Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 34.4886H17.5931V34.6167H21.5141V34.4886Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 34.6167H17.5931V34.7448H21.5141V34.6167Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 34.7441H17.5931V34.8721H21.5141V34.7441Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 34.8721H17.5931V35.0002H21.5141V34.8721Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 35.0002H17.5931V35.1283H21.5141V35.0002Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 35.1283H17.5931V35.2563H21.5141V35.1283Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 35.2563H17.5931V35.3844H21.5141V35.2563Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 35.3844H17.5931V35.5125H21.5141V35.3844Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 35.5125H17.5931V35.6405H21.5141V35.5125Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 35.6405H17.5931V35.7686H21.5141V35.6405Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 35.7679H17.5931V35.896H21.5141V35.7679Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 35.896H17.5931V36.024H21.5141V35.896Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 36.024H17.5931V36.1521H21.5141V36.024Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 36.1521H17.5931V36.2802H21.5141V36.1521Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 36.2802H17.5931V36.4082H21.5141V36.2802Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 36.4082H17.5931V36.5363H21.5141V36.4082Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 36.5363H17.5931V36.6643H21.5141V36.5363Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 36.6643H17.5931V36.7924H21.5141V36.6643Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 36.7917H17.5931V36.9198H21.5141V36.7917Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 36.9198H17.5931V37.0478H21.5141V36.9198Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 37.0479H17.5931V37.1759H21.5141V37.0479Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 37.1759H17.5931V37.304H21.5141V37.1759Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 37.304H17.5931V37.432H21.5141V37.304Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 37.432H17.5931V37.5601H21.5141V37.432Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 37.5601H17.5931V37.6882H21.5141V37.5601Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 37.6875H17.5931V37.8155H21.5141V37.6875Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 37.8155H17.5931V37.9436H21.5141V37.8155Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 37.9436H17.5931V38.0717H21.5141V37.9436Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 38.0717H17.5931V38.1997H21.5141V38.0717Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 38.1997H17.5931V38.3278H21.5141V38.1997Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 38.3278H17.5931V38.4559H21.5141V38.3278Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 38.4559H17.5931V38.5839H21.5141V38.4559Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 38.5839H17.5931V38.712H21.5141V38.5839Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 38.7113H17.5931V38.8394H21.5141V38.7113Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 38.8394H17.5931V38.9674H21.5141V38.8394Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 38.9674H17.5931V39.0955H21.5141V38.9674Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5141 39.0955H17.5931V39.2235H21.5141V39.0955Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_120_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 18,
    width: 5,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0332 39.1051V22.2476C26.0332 21.7553 26.0332 21.263 26.0332 20.77C26.0332 20.7177 26.0195 20.6764 25.9845 20.6365C25.6796 20.2874 25.3774 19.9363 25.0725 19.5872C24.6598 19.1135 24.2437 18.6425 23.8331 18.1668C23.7912 18.1179 23.7493 18.1034 23.6888 18.1034C23.204 18.1048 22.7192 18.1034 22.2337 18.1034C22.2152 18.1034 22.1967 18.1034 22.1774 18.1034C22.1479 18.1034 22.1307 18.1172 22.1314 18.1489C22.1314 18.1668 22.1314 18.1861 22.1314 18.2047C22.1225 21.3181 22.1486 24.4316 22.1191 27.5443C22.1143 28.1075 22.1259 28.6714 22.128 29.2353C22.1362 32.523 22.1314 35.8113 22.1314 39.0996C22.1314 39.1148 22.1314 39.1306 22.1314 39.1458C22.1328 39.2201 22.1335 39.2201 22.2028 39.2229C22.2214 39.2229 22.2399 39.2229 22.2592 39.2229H23.649C23.7864 39.2229 23.774 39.2325 23.774 39.0962V29.2036C23.774 29.1038 23.774 29.1031 23.8701 29.1031C24.0102 29.1031 24.1503 29.1031 24.2897 29.1031C24.392 29.1031 24.392 29.1031 24.392 29.2064V39.1079C24.392 39.1265 24.3934 39.1451 24.392 39.1643C24.3879 39.2105 24.4119 39.2256 24.4538 39.2229C24.4689 39.2215 24.4847 39.2229 24.5005 39.2229C24.973 39.2229 25.4454 39.2229 25.9185 39.2229C26.049 39.2229 26.0332 39.2208 26.0332 39.1044V39.1051ZM24.2595 27.4596C24.1263 27.4596 23.9917 27.461 23.8585 27.4596C23.7809 27.4596 23.7747 27.4527 23.774 27.3722C23.774 27.1415 23.774 26.9116 23.774 26.6802V23.7258C23.774 22.5196 23.774 21.3133 23.774 20.107C23.774 20.0781 23.7568 20.0354 23.7877 20.0209C23.8282 20.0024 23.8427 20.0499 23.8633 20.0733C23.9814 20.2096 24.0988 20.3466 24.2169 20.4829C24.2636 20.5366 24.3103 20.591 24.3584 20.6441C24.379 20.6654 24.39 20.6895 24.39 20.7191C24.39 20.7535 24.392 20.7873 24.392 20.8217V27.3295C24.392 27.4665 24.4037 27.4596 24.2588 27.4589L24.2595 27.4596Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_120_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 20.0024H23.7575V20.0547H24.4044V20.0024Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 20.054H23.7575V20.169H24.4044V20.054Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 20.169H23.7575V20.284H24.4044V20.169Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 20.284H23.7575V20.3989H24.4044V20.284Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 20.3989H23.7575V20.5139H24.4044V20.3989Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 20.5132H23.7575V20.6282H24.4044V20.5132Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 20.6282H23.7575V20.7432H24.4044V20.6282Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 20.7432H23.7575V20.8582H24.4044V20.7432Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 20.8575H23.7575V20.9725H24.4044V20.8575Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 20.9725H23.7575V21.0875H24.4044V20.9725Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 21.0875H23.7575V21.2024H24.4044V21.0875Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 21.2024H23.7575V21.3174H24.4044V21.2024Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 21.3167H23.7575V21.4317H24.4044V21.3167Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 21.4317H23.7575V21.5467H24.4044V21.4317Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 21.5467H23.7575V21.6617H24.4044V21.5467Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 21.661H23.7575V21.776H24.4044V21.661Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 21.776H23.7575V21.8909H24.4044V21.776Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 21.8909H23.7575V22.0059H24.4044V21.8909Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 22.0059H23.7575V22.1209H24.4044V22.0059Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 22.1202H23.7575V22.2352H24.4044V22.1202Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 22.2352H23.7575V22.3502H24.4044V22.2352Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 22.3502H23.7575V22.4652H24.4044V22.3502Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 22.4652H23.7575V22.5801H24.4044V22.4652Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 22.5795H23.7575V22.6944H24.4044V22.5795Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 22.6944H23.7575V22.8094H24.4044V22.6944Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 22.8094H23.7575V22.9244H24.4044V22.8094Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 22.9237H23.7575V23.0387H24.4044V22.9237Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 23.0387H23.7575V23.1537H24.4044V23.0387Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 23.1537H23.7575V23.2687H24.4044V23.1537Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 23.2687H23.7575V23.3836H24.4044V23.2687Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 23.3829H23.7575V23.4979H24.4044V23.3829Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 23.4979H23.7575V23.6129H24.4044V23.4979Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 23.6129H23.7575V23.7279H24.4044V23.6129Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 23.7272H23.7575V23.8422H24.4044V23.7272Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 23.8422H23.7575V23.9572H24.4044V23.8422Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 23.9572H23.7575V24.0722H24.4044V23.9572Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 24.0722H23.7575V24.1871H24.4044V24.0722Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 24.1865H23.7575V24.3014H24.4044V24.1865Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 24.3014H23.7575V24.4164H24.4044V24.3014Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 24.4164H23.7575V24.5314H24.4044V24.4164Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 24.5307H23.7575V24.6457H24.4044V24.5307Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 24.6457H23.7575V24.7607H24.4044V24.6457Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 24.7607H23.7575V24.8756H24.4044V24.7607Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 24.8756H23.7575V24.9906H24.4044V24.8756Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 24.9899H23.7575V25.1049H24.4044V24.9899Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 25.1049H23.7575V25.2199H24.4044V25.1049Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 25.2199H23.7575V25.3349H24.4044V25.2199Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 25.3342H23.7575V25.4492H24.4044V25.3342Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 25.4492H23.7575V25.5642H24.4044V25.4492Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 25.5642H23.7575V25.6792H24.4044V25.5642Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 25.6791H23.7575V25.7941H24.4044V25.6791Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 25.7934H23.7575V25.9084H24.4044V25.7934Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 25.9084H23.7575V26.0234H24.4044V25.9084Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 26.0234H23.7575V26.1384H24.4044V26.0234Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 26.1377H23.7575V26.2527H24.4044V26.1377Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 26.2527H23.7575V26.3677H24.4044V26.2527Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 26.3677H23.7575V26.4826H24.4044V26.3677Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 26.4826H23.7575V26.5976H24.4044V26.4826Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 26.5969H23.7575V26.7119H24.4044V26.5969Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 26.7119H23.7575V26.8269H24.4044V26.7119Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 26.8269H23.7575V26.9419H24.4044V26.8269Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 26.9412H23.7575V27.0562H24.4044V26.9412Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 27.0562H23.7575V27.1711H24.4044V27.0562Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 27.1712H23.7575V27.2861H24.4044V27.1712Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 27.2861H23.7575V27.4011H24.4044V27.2861Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4044 27.4004H23.7575V27.4672H24.4044V27.4004Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0489 18.1027H22.1141V18.2177H26.0489V18.1027Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 18.2177H22.1143V18.3327H26.049V18.2177Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 18.3327H22.1143V18.4477H26.049V18.3327Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 18.447H22.1143V18.562H26.049V18.447Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 18.562H22.1143V18.677H26.049V18.562Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 18.677H22.1143V18.792H26.049V18.677Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 18.792H22.1143V18.9069H26.049V18.792Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 18.9062H22.1143V19.0212H26.049V18.9062Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 19.0212H22.1143V19.1362H26.049V19.0212Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 19.1362H22.1143V19.2512H26.049V19.1362Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 19.2505H22.1143V19.3655H26.049V19.2505Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 19.3655H22.1143V19.4805H26.049V19.3655Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 19.4805H22.1143V19.5955H26.049V19.4805Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 19.5955H22.1143V19.7104H26.049V19.5955Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 19.7097H22.1143V19.8247H26.049V19.7097Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 19.8247H22.1143V19.9397H26.049V19.8247Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 19.9397H22.1143V20.0547H26.049V19.9397Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 20.054H22.1143V20.169H26.049V20.054Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 20.169H22.1143V20.284H26.049V20.169Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 20.284H22.1143V20.3989H26.049V20.284Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 20.3989H22.1143V20.5139H26.049V20.3989Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 20.5132H22.1143V20.6282H26.049V20.5132Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 20.6282H22.1143V20.7432H26.049V20.6282Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 20.7432H22.1143V20.8582H26.049V20.7432Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 20.8575H22.1143V20.9725H26.049V20.8575Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 20.9725H22.1143V21.0875H26.049V20.9725Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 21.0875H22.1143V21.2024H26.049V21.0875Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 21.2024H22.1143V21.3174H26.049V21.2024Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 21.3167H22.1143V21.4317H26.049V21.3167Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 21.4317H22.1143V21.5467H26.049V21.4317Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 21.5467H22.1143V21.6617H26.049V21.5467Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 21.661H22.1143V21.776H26.049V21.661Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 21.776H22.1143V21.8909H26.049V21.776Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 21.8909H22.1143V22.0059H26.049V21.8909Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 22.0059H22.1143V22.1209H26.049V22.0059Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 22.1202H22.1143V22.2352H26.049V22.1202Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 22.2352H22.1143V22.3502H26.049V22.2352Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 22.3502H22.1143V22.4652H26.049V22.3502Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 22.4652H22.1143V22.5801H26.049V22.4652Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 22.5795H22.1143V22.6944H26.049V22.5795Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 22.6944H22.1143V22.8094H26.049V22.6944Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 22.8094H22.1143V22.9244H26.049V22.8094Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 22.9237H22.1143V23.0387H26.049V22.9237Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 23.0387H22.1143V23.1537H26.049V23.0387Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 23.1537H22.1143V23.2687H26.049V23.1537Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 23.2687H22.1143V23.3836H26.049V23.2687Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 23.3829H22.1143V23.4979H26.049V23.3829Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 23.4979H22.1143V23.6129H26.049V23.4979Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 23.6129H22.1143V23.7279H26.049V23.6129Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 23.7272H22.1143V23.8422H26.049V23.7272Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 23.8422H22.1143V23.9572H26.049V23.8422Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 23.9572H22.1143V24.0722H26.049V23.9572Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 24.0722H22.1143V24.1871H26.049V24.0722Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 24.1865H22.1143V24.3014H26.049V24.1865Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 24.3014H22.1143V24.4164H26.049V24.3014Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 24.4164H22.1143V24.5314H26.049V24.4164Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 24.5307H22.1143V24.6457H26.049V24.5307Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 24.6457H22.1143V24.7607H26.049V24.6457Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 24.7607H22.1143V24.8756H26.049V24.7607Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 24.8756H22.1143V24.9906H26.049V24.8756Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 24.9899H22.1143V25.1049H26.049V24.9899Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 25.1049H22.1143V25.2199H26.049V25.1049Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 25.2199H22.1143V25.3349H26.049V25.2199Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 25.3342H22.1143V25.4492H26.049V25.3342Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 25.4492H22.1143V25.5642H26.049V25.4492Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 25.5642H22.1143V25.6792H26.049V25.5642Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 25.6791H22.1143V25.7941H26.049V25.6791Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 25.7934H22.1143V25.9084H26.049V25.7934Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 25.9084H22.1143V26.0234H26.049V25.9084Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 26.0234H22.1143V26.1384H26.049V26.0234Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 26.1377H22.1143V26.2527H26.049V26.1377Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 26.2527H22.1143V26.3677H26.049V26.2527Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 26.3677H22.1143V26.4826H26.049V26.3677Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 26.4826H22.1143V26.5976H26.049V26.4826Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 26.5969H22.1143V26.7119H26.049V26.5969Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 26.7119H22.1143V26.8269H26.049V26.7119Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 26.8269H22.1143V26.9419H26.049V26.8269Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 26.9412H22.1143V27.0562H26.049V26.9412Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 27.0562H22.1143V27.1711H26.049V27.0562Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 27.1712H22.1143V27.2861H26.049V27.1712Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 27.2861H22.1143V27.4011H26.049V27.2861Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 27.4004H22.1143V27.5154H26.049V27.4004Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 27.5154H22.1143V27.6304H26.049V27.5154Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 27.6304H22.1143V27.7454H26.049V27.6304Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 27.7454H22.1143V27.8604H26.049V27.7454Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 27.8597H22.1143V27.9746H26.049V27.8597Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 27.9746H22.1143V28.0896H26.049V27.9746Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 28.0896H22.1143V28.2046H26.049V28.0896Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 28.2039H22.1143V28.3189H26.049V28.2039Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 28.3189H22.1143V28.4339H26.049V28.3189Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 28.4339H22.1143V28.5489H26.049V28.4339Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 28.5489H22.1143V28.6638H26.049V28.5489Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 28.6632H22.1143V28.7781H26.049V28.6632Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 28.7781H22.1143V28.8931H26.049V28.7781Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 28.8931H22.1143V29.0081H26.049V28.8931Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 29.0074H22.1143V29.1224H26.049V29.0074Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 29.1224H22.1143V29.2374H26.049V29.1224Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 29.2374H22.1143V29.3524H26.049V29.2374Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 29.3524H22.1143V29.4673H26.049V29.3524Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 29.4667H22.1143V29.5816H26.049V29.4667Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 29.5816H22.1143V29.6966H26.049V29.5816Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 29.6966H22.1143V29.8116H26.049V29.6966Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 29.8109H22.1143V29.9259H26.049V29.8109Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 29.9259H22.1143V30.0409H26.049V29.9259Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 30.0409H22.1143V30.1559H26.049V30.0409Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 30.1559H22.1143V30.2708H26.049V30.1559Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 30.2701H22.1143V30.3851H26.049V30.2701Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 30.3851H22.1143V30.5001H26.049V30.3851Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 30.5001H22.1143V30.6151H26.049V30.5001Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 30.6144H22.1143V30.7294H26.049V30.6144Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 30.7294H22.1143V30.8444H26.049V30.7294Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 30.8444H22.1143V30.9593H26.049V30.8444Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 30.9594H22.1143V31.0743H26.049V30.9594Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 31.0736H22.1143V31.1886H26.049V31.0736Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 31.1886H22.1143V31.3036H26.049V31.1886Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 31.3036H22.1143V31.4186H26.049V31.3036Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 31.4179H22.1143V31.5329H26.049V31.4179Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 31.5329H22.1143V31.6479H26.049V31.5329Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 31.6479H22.1143V31.7628H26.049V31.6479Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 31.7628H22.1143V31.8778H26.049V31.7628Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 31.8771H22.1143V31.9921H26.049V31.8771Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 31.9921H22.1143V32.1071H26.049V31.9921Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 32.1071H22.1143V32.2221H26.049V32.1071Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 32.2214H22.1143V32.3364H26.049V32.2214Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 32.3364H22.1143V32.4514H26.049V32.3364Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 32.4513H22.1143V32.5663H26.049V32.4513Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 32.5663H22.1143V32.6813H26.049V32.5663Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 32.6806H22.1143V32.7956H26.049V32.6806Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 32.7956H22.1143V32.9106H26.049V32.7956Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 32.9106H22.1143V33.0256H26.049V32.9106Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 33.0256H22.1143V33.1406H26.049V33.0256Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 33.1399H22.1143V33.2548H26.049V33.1399Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 33.2548H22.1143V33.3698H26.049V33.2548Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 33.3698H22.1143V33.4848H26.049V33.3698Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 33.4841H22.1143V33.5991H26.049V33.4841Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 33.5991H22.1143V33.7141H26.049V33.5991Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 33.7141H22.1143V33.8291H26.049V33.7141Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 33.8291H22.1143V33.944H26.049V33.8291Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 33.9434H22.1143V34.0583H26.049V33.9434Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 34.0583H22.1143V34.1733H26.049V34.0583Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 34.1733H22.1143V34.2883H26.049V34.1733Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 34.2876H22.1143V34.4026H26.049V34.2876Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 34.4026H22.1143V34.5176H26.049V34.4026Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 34.5176H22.1143V34.6326H26.049V34.5176Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 34.6326H22.1143V34.7475H26.049V34.6326Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 34.7469H22.1143V34.8618H26.049V34.7469Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 34.8618H22.1143V34.9768H26.049V34.8618Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 34.9768H22.1143V35.0918H26.049V34.9768Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 35.0911H22.1143V35.2061H26.049V35.0911Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 35.2061H22.1143V35.3211H26.049V35.2061Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 35.3211H22.1143V35.436H26.049V35.3211Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 35.4361H22.1143V35.551H26.049V35.4361Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 35.5503H22.1143V35.6653H26.049V35.5503Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 35.6653H22.1143V35.7803H26.049V35.6653Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 35.7803H22.1143V35.8953H26.049V35.7803Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 35.8946H22.1143V36.0096H26.049V35.8946Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 36.0096H22.1143V36.1246H26.049V36.0096Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 36.1246H22.1143V36.2395H26.049V36.1246Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 36.2395H22.1143V36.3545H26.049V36.2395Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 36.3538H22.1143V36.4688H26.049V36.3538Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 36.4688H22.1143V36.5838H26.049V36.4688Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 36.5838H22.1143V36.6988H26.049V36.5838Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 36.6981H22.1143V36.8131H26.049V36.6981Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 36.8131H22.1143V36.9281H26.049V36.8131Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 36.9281H22.1143V37.043H26.049V36.9281Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 37.043H22.1143V37.158H26.049V37.043Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 37.1573H22.1143V37.2723H26.049V37.1573Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 37.2723H22.1143V37.3873H26.049V37.2723Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 37.3873H22.1143V37.5023H26.049V37.3873Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 37.5023H22.1143V37.6173H26.049V37.5023Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 37.6166H22.1143V37.7315H26.049V37.6166Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 37.7316H22.1143V37.8465H26.049V37.7316Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 37.8465H22.1143V37.9615H26.049V37.8465Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 37.9608H22.1143V38.0758H26.049V37.9608Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 38.0758H22.1143V38.1908H26.049V38.0758Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 38.1908H22.1143V38.3058H26.049V38.1908Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 38.3058H22.1143V38.4208H26.049V38.3058Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 38.4201H22.1143V38.535H26.049V38.4201Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 38.535H22.1143V38.65H26.049V38.535Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 38.65H22.1143V38.765H26.049V38.65Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 38.7643H22.1143V38.8793H26.049V38.7643Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 38.8793H22.1143V38.9943H26.049V38.8793Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 38.9943H22.1143V39.1093H26.049V38.9943Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.049 39.1093H22.1143V39.2243H26.049V39.1093Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_120_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 5,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5729 37.4789C30.5516 36.6506 30.5674 35.8209 30.5674 34.992C30.5674 31.7105 30.5674 28.4291 30.5688 25.1476C30.5688 25.1028 30.5564 25.0719 30.5235 25.0429C30.3655 24.9073 30.2089 24.7696 30.051 24.634C29.4879 24.1493 28.9241 23.6652 28.3617 23.1798C28.3288 23.1516 28.2972 23.1378 28.2533 23.1378C27.7492 23.1392 27.2459 23.1378 26.7425 23.1392C26.6691 23.1392 26.6691 23.1413 26.667 23.2108C26.667 23.2239 26.667 23.2363 26.667 23.248V39.1223C26.667 39.2483 26.656 39.2394 26.781 39.2394H30.4658C30.4843 39.2394 30.5029 39.2394 30.5221 39.2394C30.5859 39.2366 30.5866 39.2366 30.5887 39.1678C30.5887 39.1492 30.5887 39.1306 30.5887 39.1113C30.5784 38.5667 30.5887 38.0228 30.5743 37.4782L30.5729 37.4789ZM28.9255 25.2247V37.4699C28.9255 37.6014 28.9344 37.5925 28.806 37.5925C28.6632 37.5925 28.5204 37.5925 28.3769 37.5925C28.313 37.5925 28.3096 37.587 28.3068 37.5229C28.3068 37.5071 28.3068 37.4913 28.3068 37.4761V31.0729C28.3068 28.942 28.3068 26.8104 28.3068 24.6794C28.3068 24.6471 28.2876 24.6023 28.3219 24.5844C28.359 24.5658 28.3782 24.6126 28.4029 24.6326C28.5629 24.7662 28.7209 24.9018 28.8809 25.0347C28.9125 25.0608 28.929 25.0898 28.9255 25.1311C28.9235 25.1621 28.9255 25.193 28.9255 25.2247Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_120_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 24.5651H28.2876V24.625H28.9338V24.5651Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 24.625H28.2876V24.7125H28.9338V24.625Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 24.7125H28.2876V24.7999H28.9338V24.7125Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 24.7999H28.2876V24.8873H28.9338V24.7999Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 24.8873H28.2876V24.9748H28.9338V24.8873Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 24.9748H28.2876V25.0622H28.9338V24.9748Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 25.0622H28.2876V25.1497H28.9338V25.0622Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 25.1503H28.2876V25.2378H28.9338V25.1503Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 25.2378H28.2876V25.3252H28.9338V25.2378Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 25.3252H28.2876V25.4127H28.9338V25.3252Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 25.4127H28.2876V25.5001H28.9338V25.4127Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 25.5001H28.2876V25.5876H28.9338V25.5001Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 25.5876H28.2876V25.675H28.9338V25.5876Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 25.675H28.2876V25.7624H28.9338V25.675Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 25.7624H28.2876V25.8499H28.9338V25.7624Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 25.8499H28.2876V25.9373H28.9338V25.8499Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 25.938H28.2876V26.0254H28.9338V25.938Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 26.0255H28.2876V26.1129H28.9338V26.0255Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 26.1129H28.2876V26.2003H28.9338V26.1129Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 26.2003H28.2876V26.2878H28.9338V26.2003Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 26.2878H28.2876V26.3752H28.9338V26.2878Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 26.3752H28.2876V26.4627H28.9338V26.3752Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 26.4627H28.2876V26.5501H28.9338V26.4627Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 26.5501H28.2876V26.6375H28.9338V26.5501Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 26.6375H28.2876V26.725H28.9338V26.6375Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 26.725H28.2876V26.8124H28.9338V26.725Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 26.8131H28.2876V26.9006H28.9338V26.8131Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 26.9006H28.2876V26.988H28.9338V26.9006Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 26.988H28.2876V27.0754H28.9338V26.988Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 27.0754H28.2876V27.1629H28.9338V27.0754Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 27.1629H28.2876V27.2503H28.9338V27.1629Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 27.2503H28.2876V27.3378H28.9338V27.2503Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 27.3378H28.2876V27.4252H28.9338V27.3378Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 27.4252H28.2876V27.5126H28.9338V27.4252Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 27.5126H28.2876V27.6001H28.9338V27.5126Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 27.6001H28.2876V27.6875H28.9338V27.6001Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 27.6882H28.2876V27.7756H28.9338V27.6882Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 27.7757H28.2876V27.8631H28.9338V27.7757Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 27.8631H28.2876V27.9505H28.9338V27.8631Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 27.9505H28.2876V28.038H28.9338V27.9505Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 28.038H28.2876V28.1254H28.9338V28.038Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 28.1254H28.2876V28.2129H28.9338V28.1254Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 28.2129H28.2876V28.3003H28.9338V28.2129Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 28.3003H28.2876V28.3877H28.9338V28.3003Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 28.3877H28.2876V28.4752H28.9338V28.3877Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 28.4752H28.2876V28.5626H28.9338V28.4752Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 28.5633H28.2876V28.6508H28.9338V28.5633Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 28.6508H28.2876V28.7382H28.9338V28.6508Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 28.7382H28.2876V28.8256H28.9338V28.7382Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 28.8256H28.2876V28.9131H28.9338V28.8256Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 28.9131H28.2876V29.0005H28.9338V28.9131Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 29.0005H28.2876V29.088H28.9338V29.0005Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 29.088H28.2876V29.1754H28.9338V29.088Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 29.1754H28.2876V29.2628H28.9338V29.1754Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 29.2628H28.2876V29.3503H28.9338V29.2628Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 29.3503H28.2876V29.4377H28.9338V29.3503Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 29.4384H28.2876V29.5258H28.9338V29.4384Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 29.5258H28.2876V29.6133H28.9338V29.5258Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 29.6133H28.2876V29.7007H28.9338V29.6133Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 29.7007H28.2876V29.7882H28.9338V29.7007Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 29.7882H28.2876V29.8756H28.9338V29.7882Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 29.8756H28.2876V29.9631H28.9338V29.8756Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 29.9631H28.2876V30.0505H28.9338V29.9631Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 30.0505H28.2876V30.1379H28.9338V30.0505Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 30.1379H28.2876V30.2254H28.9338V30.1379Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 30.2261H28.2876V30.3135H28.9338V30.2261Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 30.3135H28.2876V30.4009H28.9338V30.3135Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 30.4009H28.2876V30.4884H28.9338V30.4009Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 30.4884H28.2876V30.5758H28.9338V30.4884Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 30.5758H28.2876V30.6633H28.9338V30.5758Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 30.6633H28.2876V30.7507H28.9338V30.6633Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 30.7507H28.2876V30.8382H28.9338V30.7507Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 30.8382H28.2876V30.9256H28.9338V30.8382Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 30.9256H28.2876V31.013H28.9338V30.9256Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 31.013H28.2876V31.1005H28.9338V31.013Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 31.1012H28.2876V31.1886H28.9338V31.1012Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 31.1886H28.2876V31.2761H28.9338V31.1886Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 31.276H28.2876V31.3635H28.9338V31.276Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 31.3635H28.2876V31.4509H28.9338V31.3635Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 31.4509H28.2876V31.5384H28.9338V31.4509Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 31.5384H28.2876V31.6258H28.9338V31.5384Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 31.6258H28.2876V31.7133H28.9338V31.6258Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 31.7133H28.2876V31.8007H28.9338V31.7133Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 31.8007H28.2876V31.8881H28.9338V31.8007Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 31.8881H28.2876V31.9756H28.9338V31.8881Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 31.9763H28.2876V32.0637H28.9338V31.9763Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 32.0637H28.2876V32.1511H28.9338V32.0637Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 32.1511H28.2876V32.2386H28.9338V32.1511Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 32.2386H28.2876V32.326H28.9338V32.2386Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 32.326H28.2876V32.4135H28.9338V32.326Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 32.4135H28.2876V32.5009H28.9338V32.4135Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 32.5009H28.2876V32.5883H28.9338V32.5009Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 32.5884H28.2876V32.6758H28.9338V32.5884Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 32.6758H28.2876V32.7632H28.9338V32.6758Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 32.7632H28.2876V32.8507H28.9338V32.7632Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 32.8514H28.2876V32.9388H28.9338V32.8514Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 32.9388H28.2876V33.0262H28.9338V32.9388Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 33.0263H28.2876V33.1137H28.9338V33.0263Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 33.1137H28.2876V33.2011H28.9338V33.1137Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 33.2011H28.2876V33.2886H28.9338V33.2011Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 33.2886H28.2876V33.376H28.9338V33.2886Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 33.376H28.2876V33.4634H28.9338V33.376Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 33.4634H28.2876V33.5509H28.9338V33.4634Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 33.5509H28.2876V33.6383H28.9338V33.5509Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 33.639H28.2876V33.7265H28.9338V33.639Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 33.7265H28.2876V33.8139H28.9338V33.7265Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 33.8139H28.2876V33.9013H28.9338V33.8139Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 33.9014H28.2876V33.9888H28.9338V33.9014Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 33.9888H28.2876V34.0762H28.9338V33.9888Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 34.0762H28.2876V34.1637H28.9338V34.0762Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 34.1637H28.2876V34.2511H28.9338V34.1637Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 34.2511H28.2876V34.3385H28.9338V34.2511Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 34.3385H28.2876V34.426H28.9338V34.3385Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 34.426H28.2876V34.5134H28.9338V34.426Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 34.5141H28.2876V34.6016H28.9338V34.5141Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 34.6016H28.2876V34.689H28.9338V34.6016Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 34.689H28.2876V34.7764H28.9338V34.689Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 34.7765H28.2876V34.8639H28.9338V34.7765Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 34.8639H28.2876V34.9513H28.9338V34.8639Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 34.9513H28.2876V35.0388H28.9338V34.9513Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 35.0388H28.2876V35.1262H28.9338V35.0388Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 35.1262H28.2876V35.2136H28.9338V35.1262Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 35.2136H28.2876V35.3011H28.9338V35.2136Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 35.3011H28.2876V35.3885H28.9338V35.3011Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 35.3892H28.2876V35.4767H28.9338V35.3892Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 35.4767H28.2876V35.5641H28.9338V35.4767Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 35.5641H28.2876V35.6515H28.9338V35.5641Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 35.6515H28.2876V35.739H28.9338V35.6515Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 35.739H28.2876V35.8264H28.9338V35.739Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 35.8264H28.2876V35.9139H28.9338V35.8264Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 35.9139H28.2876V36.0013H28.9338V35.9139Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 36.0013H28.2876V36.0888H28.9338V36.0013Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 36.0887H28.2876V36.1762H28.9338V36.0887Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 36.1762H28.2876V36.2636H28.9338V36.1762Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 36.2643H28.2876V36.3518H28.9338V36.2643Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 36.3518H28.2876V36.4392H28.9338V36.3518Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 36.4392H28.2876V36.5266H28.9338V36.4392Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 36.5266H28.2876V36.6141H28.9338V36.5266Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 36.6141H28.2876V36.7015H28.9338V36.6141Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 36.7015H28.2876V36.789H28.9338V36.7015Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 36.789H28.2876V36.8764H28.9338V36.789Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 36.8764H28.2876V36.9638H28.9338V36.8764Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 36.9638H28.2876V37.0513H28.9338V36.9638Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 37.052H28.2876V37.1394H28.9338V37.052Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 37.1394H28.2876V37.2269H28.9338V37.1394Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 37.2269H28.2876V37.3143H28.9338V37.2269Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 37.3143H28.2876V37.4017H28.9338V37.3143Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 37.4017H28.2876V37.4892H28.9338V37.4017Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 37.4892H28.2876V37.5766H28.9338V37.4892Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9338 37.5766H28.2876V37.6014H28.9338V37.5766Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5879 23.1371H26.6559V23.2246H30.5879V23.1371Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 23.2246H26.656V23.312H30.588V23.2246Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 23.312H26.656V23.3995H30.588V23.312Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 23.4001H26.656V23.4876H30.588V23.4001Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 23.4876H26.656V23.575H30.588V23.4876Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 23.575H26.656V23.6625H30.588V23.575Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 23.6625H26.656V23.7499H30.588V23.6625Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 23.7499H26.656V23.8374H30.588V23.7499Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 23.8373H26.656V23.9248H30.588V23.8373Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 23.9248H26.656V24.0122H30.588V23.9248Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 24.0122H26.656V24.0997H30.588V24.0122Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 24.0997H26.656V24.1871H30.588V24.0997Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 24.1871H26.656V24.2746H30.588V24.1871Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 24.2753H26.656V24.3627H30.588V24.2753Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 24.3627H26.656V24.4501H30.588V24.3627Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 24.4501H26.656V24.5376H30.588V24.4501Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 24.5376H26.656V24.625H30.588V24.5376Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 24.625H26.656V24.7125H30.588V24.625Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 24.7125H26.656V24.7999H30.588V24.7125Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 24.7999H26.656V24.8873H30.588V24.7999Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 24.8873H26.656V24.9748H30.588V24.8873Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 24.9748H26.656V25.0622H30.588V24.9748Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 25.0622H26.656V25.1497H30.588V25.0622Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 25.1503H26.656V25.2378H30.588V25.1503Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 25.2378H26.656V25.3252H30.588V25.2378Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 25.3252H26.656V25.4127H30.588V25.3252Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 25.4127H26.656V25.5001H30.588V25.4127Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 25.5001H26.656V25.5876H30.588V25.5001Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 25.5876H26.656V25.675H30.588V25.5876Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 25.675H26.656V25.7624H30.588V25.675Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 25.7624H26.656V25.8499H30.588V25.7624Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 25.8499H26.656V25.9373H30.588V25.8499Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 25.938H26.656V26.0254H30.588V25.938Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 26.0255H26.656V26.1129H30.588V26.0255Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 26.1129H26.656V26.2003H30.588V26.1129Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 26.2003H26.656V26.2878H30.588V26.2003Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 26.2878H26.656V26.3752H30.588V26.2878Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 26.3752H26.656V26.4627H30.588V26.3752Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 26.4627H26.656V26.5501H30.588V26.4627Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 26.5501H26.656V26.6375H30.588V26.5501Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 26.6375H26.656V26.725H30.588V26.6375Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 26.725H26.656V26.8124H30.588V26.725Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 26.8131H26.656V26.9006H30.588V26.8131Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 26.9006H26.656V26.988H30.588V26.9006Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 26.988H26.656V27.0754H30.588V26.988Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 27.0754H26.656V27.1629H30.588V27.0754Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 27.1629H26.656V27.2503H30.588V27.1629Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 27.2503H26.656V27.3378H30.588V27.2503Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 27.3378H26.656V27.4252H30.588V27.3378Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 27.4252H26.656V27.5126H30.588V27.4252Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 27.5126H26.656V27.6001H30.588V27.5126Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 27.6001H26.656V27.6875H30.588V27.6001Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 27.6882H26.656V27.7756H30.588V27.6882Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 27.7757H26.656V27.8631H30.588V27.7757Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 27.8631H26.656V27.9505H30.588V27.8631Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 27.9505H26.656V28.038H30.588V27.9505Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 28.038H26.656V28.1254H30.588V28.038Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 28.1254H26.656V28.2129H30.588V28.1254Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 28.2129H26.656V28.3003H30.588V28.2129Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 28.3003H26.656V28.3877H30.588V28.3003Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 28.3877H26.656V28.4752H30.588V28.3877Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 28.4752H26.656V28.5626H30.588V28.4752Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 28.5633H26.656V28.6508H30.588V28.5633Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 28.6508H26.656V28.7382H30.588V28.6508Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 28.7382H26.656V28.8256H30.588V28.7382Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 28.8256H26.656V28.9131H30.588V28.8256Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 28.9131H26.656V29.0005H30.588V28.9131Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 29.0005H26.656V29.088H30.588V29.0005Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 29.088H26.656V29.1754H30.588V29.088Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 29.1754H26.656V29.2628H30.588V29.1754Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 29.2628H26.656V29.3503H30.588V29.2628Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 29.3503H26.656V29.4377H30.588V29.3503Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 29.4384H26.656V29.5258H30.588V29.4384Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 29.5258H26.656V29.6133H30.588V29.5258Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 29.6133H26.656V29.7007H30.588V29.6133Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 29.7007H26.656V29.7882H30.588V29.7007Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 29.7882H26.656V29.8756H30.588V29.7882Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 29.8756H26.656V29.9631H30.588V29.8756Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 29.9631H26.656V30.0505H30.588V29.9631Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 30.0505H26.656V30.1379H30.588V30.0505Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 30.1379H26.656V30.2254H30.588V30.1379Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 30.2261H26.656V30.3135H30.588V30.2261Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 30.3135H26.656V30.4009H30.588V30.3135Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 30.4009H26.656V30.4884H30.588V30.4009Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 30.4884H26.656V30.5758H30.588V30.4884Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 30.5758H26.656V30.6633H30.588V30.5758Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 30.6633H26.656V30.7507H30.588V30.6633Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 30.7507H26.656V30.8382H30.588V30.7507Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 30.8382H26.656V30.9256H30.588V30.8382Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 30.9256H26.656V31.013H30.588V30.9256Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 31.013H26.656V31.1005H30.588V31.013Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 31.1012H26.656V31.1886H30.588V31.1012Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 31.1886H26.656V31.2761H30.588V31.1886Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 31.276H26.656V31.3635H30.588V31.276Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 31.3635H26.656V31.4509H30.588V31.3635Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 31.4509H26.656V31.5384H30.588V31.4509Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 31.5384H26.656V31.6258H30.588V31.5384Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 31.6258H26.656V31.7133H30.588V31.6258Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 31.7133H26.656V31.8007H30.588V31.7133Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 31.8007H26.656V31.8881H30.588V31.8007Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 31.8881H26.656V31.9756H30.588V31.8881Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 31.9763H26.656V32.0637H30.588V31.9763Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 32.0637H26.656V32.1511H30.588V32.0637Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 32.1511H26.656V32.2386H30.588V32.1511Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 32.2386H26.656V32.326H30.588V32.2386Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 32.326H26.656V32.4135H30.588V32.326Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 32.4135H26.656V32.5009H30.588V32.4135Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 32.5009H26.656V32.5883H30.588V32.5009Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 32.5884H26.656V32.6758H30.588V32.5884Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 32.6758H26.656V32.7632H30.588V32.6758Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 32.7632H26.656V32.8507H30.588V32.7632Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 32.8514H26.656V32.9388H30.588V32.8514Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 32.9388H26.656V33.0262H30.588V32.9388Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 33.0263H26.656V33.1137H30.588V33.0263Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 33.1137H26.656V33.2011H30.588V33.1137Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 33.2011H26.656V33.2886H30.588V33.2011Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 33.2886H26.656V33.376H30.588V33.2886Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 33.376H26.656V33.4634H30.588V33.376Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 33.4634H26.656V33.5509H30.588V33.4634Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 33.5509H26.656V33.6383H30.588V33.5509Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 33.639H26.656V33.7265H30.588V33.639Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 33.7265H26.656V33.8139H30.588V33.7265Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 33.8139H26.656V33.9013H30.588V33.8139Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 33.9014H26.656V33.9888H30.588V33.9014Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 33.9888H26.656V34.0762H30.588V33.9888Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 34.0762H26.656V34.1637H30.588V34.0762Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 34.1637H26.656V34.2511H30.588V34.1637Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 34.2511H26.656V34.3385H30.588V34.2511Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 34.3385H26.656V34.426H30.588V34.3385Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 34.426H26.656V34.5134H30.588V34.426Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 34.5141H26.656V34.6016H30.588V34.5141Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 34.6016H26.656V34.689H30.588V34.6016Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 34.689H26.656V34.7764H30.588V34.689Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 34.7765H26.656V34.8639H30.588V34.7765Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 34.8639H26.656V34.9513H30.588V34.8639Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 34.9513H26.656V35.0388H30.588V34.9513Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 35.0388H26.656V35.1262H30.588V35.0388Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 35.1262H26.656V35.2136H30.588V35.1262Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 35.2136H26.656V35.3011H30.588V35.2136Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 35.3011H26.656V35.3885H30.588V35.3011Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 35.3892H26.656V35.4767H30.588V35.3892Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 35.4767H26.656V35.5641H30.588V35.4767Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 35.5641H26.656V35.6515H30.588V35.5641Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 35.6515H26.656V35.739H30.588V35.6515Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 35.739H26.656V35.8264H30.588V35.739Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 35.8264H26.656V35.9139H30.588V35.8264Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 35.9139H26.656V36.0013H30.588V35.9139Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 36.0013H26.656V36.0888H30.588V36.0013Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 36.0887H26.656V36.1762H30.588V36.0887Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 36.1762H26.656V36.2636H30.588V36.1762Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 36.2643H26.656V36.3518H30.588V36.2643Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 36.3518H26.656V36.4392H30.588V36.3518Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 36.4392H26.656V36.5266H30.588V36.4392Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 36.5266H26.656V36.6141H30.588V36.5266Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 36.6141H26.656V36.7015H30.588V36.6141Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 36.7015H26.656V36.789H30.588V36.7015Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 36.789H26.656V36.8764H30.588V36.789Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 36.8764H26.656V36.9638H30.588V36.8764Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 36.9638H26.656V37.0513H30.588V36.9638Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 37.052H26.656V37.1394H30.588V37.052Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 37.1394H26.656V37.2269H30.588V37.1394Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 37.2269H26.656V37.3143H30.588V37.2269Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 37.3143H26.656V37.4017H30.588V37.3143Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 37.4017H26.656V37.4892H30.588V37.4017Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 37.4892H26.656V37.5766H30.588V37.4892Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 37.5766H26.656V37.6641H30.588V37.5766Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 37.6641H26.656V37.7515H30.588V37.6641Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 37.7515H26.656V37.8389H30.588V37.7515Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 37.8389H26.656V37.9264H30.588V37.8389Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 37.9271H26.656V38.0145H30.588V37.9271Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 38.0145H26.656V38.102H30.588V38.0145Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 38.102H26.656V38.1894H30.588V38.102Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 38.1894H26.656V38.2768H30.588V38.1894Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 38.2768H26.656V38.3643H30.588V38.2768Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 38.3643H26.656V38.4517H30.588V38.3643Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 38.4517H26.656V38.5392H30.588V38.4517Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 38.5392H26.656V38.6266H30.588V38.5392Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 38.6266H26.656V38.714H30.588V38.6266Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 38.714H26.656V38.8015H30.588V38.714Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 38.8022H26.656V38.8896H30.588V38.8022Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 38.8896H26.656V38.9771H30.588V38.8896Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 38.9771H26.656V39.0645H30.588V38.9771Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 39.0645H26.656V39.1519H30.588V39.0645Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 39.1519H26.656V39.2394H30.588V39.1519Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.588 39.2394H26.656V39.2483H30.588V39.2394Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_120_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 23,
    width: 5,
    height: 17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0512 24.5644C12.9853 24.5982 12.9414 24.6512 12.8906 24.6939C12.7546 24.8075 12.6227 24.9259 12.4882 25.0409C12.4524 25.0712 12.4339 25.1042 12.4353 25.1531C12.438 25.2653 12.436 25.3776 12.436 25.4898C12.436 26.9419 12.436 28.3946 12.436 29.8467C12.436 29.961 12.4243 29.9617 12.5548 29.9617C13.2298 29.9617 13.9041 29.9617 14.5791 29.9617C14.5977 29.9617 14.6162 29.9617 14.6347 29.9617C14.7048 29.9638 14.7048 29.9638 14.7062 30.0367C14.7069 30.0774 14.7062 30.118 14.7062 30.1586C14.7062 33.1378 14.7062 36.1177 14.7062 39.0969C14.7062 39.2304 14.7247 39.2229 14.5819 39.2229C14.1156 39.2229 13.6493 39.2229 13.1824 39.2229C13.1577 39.2229 13.133 39.2229 13.1075 39.2229C13.0766 39.2229 13.0622 39.2077 13.0629 39.1767C13.0629 39.1547 13.0629 39.1334 13.0629 39.1113C13.0629 36.6526 13.0629 34.1933 13.0629 31.7346C13.0629 31.6003 13.0739 31.6086 12.9366 31.6086C12.7965 31.6086 12.6564 31.6079 12.517 31.6086C12.4449 31.6086 12.438 31.6169 12.436 31.6899C12.4353 31.7243 12.436 31.7587 12.436 31.7924C12.436 33.5006 12.436 35.2081 12.436 36.9163C12.436 36.9198 12.436 36.9225 12.436 36.926C12.436 37.0286 12.436 37.0286 12.3343 37.0286C11.8585 37.0286 11.3826 37.0286 10.9074 37.0286C10.8888 37.0286 10.8703 37.0286 10.8518 37.0286C10.8215 37.0286 10.8058 37.0141 10.8058 36.9831C10.8058 36.9645 10.8058 36.946 10.8058 36.9274C10.8058 33.0097 10.8058 29.0921 10.8044 25.1745C10.8044 25.1077 10.8277 25.0657 10.8758 25.0237C11.2947 24.6615 11.7122 24.298 12.1297 23.9351C12.416 23.6859 12.7031 23.438 12.9881 23.1874C13.0451 23.1372 13.1027 23.1151 13.1803 23.1158C13.65 23.1192 14.119 23.1179 14.5887 23.1179C14.6107 23.1179 14.632 23.1179 14.654 23.1179C14.6876 23.1172 14.7069 23.131 14.7062 23.1668C14.7062 23.1888 14.7062 23.2101 14.7062 23.2322C14.7062 25.2516 14.7062 27.271 14.7062 29.2911C14.7062 29.3069 14.7048 29.3221 14.7062 29.3379C14.7103 29.3813 14.6924 29.4012 14.6478 29.3992C14.6045 29.3971 14.5606 29.3992 14.5173 29.3992C14.073 29.3992 13.6281 29.3992 13.1838 29.3992C13.1618 29.3992 13.1405 29.3985 13.1185 29.3992C13.0801 29.4012 13.0602 29.3847 13.0629 29.3448C13.0643 29.3262 13.0629 29.3076 13.0629 29.289C13.0629 27.7461 13.0629 26.2038 13.0629 24.6608C13.0629 24.6312 13.0691 24.5996 13.0512 24.5658V24.5644Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_120_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7242 23.1161H10.8032V23.2036H14.7242V23.1161Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 23.2032H10.8031V23.2907H14.7241V23.2032Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 23.2907H10.8031V23.3781H14.7241V23.2907Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 23.3781H10.8031V23.4656H14.7241V23.3781Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 23.4656H10.8031V23.553H14.7241V23.4656Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 23.5537H10.8031V23.6411H14.7241V23.5537Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 23.6411H10.8031V23.7286H14.7241V23.6411Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 23.7286H10.8031V23.816H14.7241V23.7286Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 23.816H10.8031V23.9035H14.7241V23.816Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 23.9035H10.8031V23.9909H14.7241V23.9035Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 23.9909H10.8031V24.0783H14.7241V23.9909Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 24.0783H10.8031V24.1658H14.7241V24.0783Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 24.1665H10.8031V24.2539H14.7241V24.1665Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 24.2539H10.8031V24.3414H14.7241V24.2539Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 24.3414H10.8031V24.4288H14.7241V24.3414Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 24.4288H10.8031V24.5162H14.7241V24.4288Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 24.5162H10.8031V24.6037H14.7241V24.5162Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 24.6037H10.8031V24.6911H14.7241V24.6037Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 24.6911H10.8031V24.7786H14.7241V24.6911Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 24.7793H10.8031V24.8667H14.7241V24.7793Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 24.8667H10.8031V24.9541H14.7241V24.8667Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 24.9541H10.8031V25.0416H14.7241V24.9541Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 25.0416H10.8031V25.129H14.7241V25.0416Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 25.129H10.8031V25.2165H14.7241V25.129Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 25.2165H10.8031V25.3039H14.7241V25.2165Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 25.3039H10.8031V25.3913H14.7241V25.3039Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 25.392H10.8031V25.4795H14.7241V25.392Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 25.4795H10.8031V25.5669H14.7241V25.4795Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 25.5669H10.8031V25.6543H14.7241V25.5669Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 25.6543H10.8031V25.7418H14.7241V25.6543Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 25.7418H10.8031V25.8292H14.7241V25.7418Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 25.8292H10.8031V25.9167H14.7241V25.8292Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 25.9174H10.8031V26.0048H14.7241V25.9174Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 26.0048H10.8031V26.0922H14.7241V26.0048Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 26.0922H10.8031V26.1797H14.7241V26.0922Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 26.1797H10.8031V26.2671H14.7241V26.1797Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 26.2671H10.8031V26.3546H14.7241V26.2671Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 26.3546H10.8031V26.442H14.7241V26.3546Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 26.442H10.8031V26.5295H14.7241V26.442Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 26.5301H10.8031V26.6176H14.7241V26.5301Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 26.6176H10.8031V26.705H14.7241V26.6176Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 26.705H10.8031V26.7925H14.7241V26.705Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 26.7925H10.8031V26.8799H14.7241V26.7925Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 26.8799H10.8031V26.9673H14.7241V26.8799Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 26.9673H10.8031V27.0548H14.7241V26.9673Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 27.0548H10.8031V27.1422H14.7241V27.0548Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 27.1429H10.8031V27.2304H14.7241V27.1429Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 27.2304H10.8031V27.3178H14.7241V27.2304Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 27.3178H10.8031V27.4052H14.7241V27.3178Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 27.4052H10.8031V27.4927H14.7241V27.4052Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 27.4927H10.8031V27.5801H14.7241V27.4927Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 27.5801H10.8031V27.6676H14.7241V27.5801Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 27.6676H10.8031V27.755H14.7241V27.6676Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 27.7557H10.8031V27.8431H14.7241V27.7557Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 27.8431H10.8031V27.9306H14.7241V27.8431Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 27.9306H10.8031V28.018H14.7241V27.9306Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 28.018H10.8031V28.1055H14.7241V28.018Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 28.1055H10.8031V28.1929H14.7241V28.1055Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 28.1929H10.8031V28.2803H14.7241V28.1929Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 28.2803H10.8031V28.3678H14.7241V28.2803Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 28.3685H10.8031V28.4559H14.7241V28.3685Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 28.4559H10.8031V28.5433H14.7241V28.4559Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 28.5434H10.8031V28.6308H14.7241V28.5434Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 28.6308H10.8031V28.7182H14.7241V28.6308Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 28.7182H10.8031V28.8057H14.7241V28.7182Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 28.8057H10.8031V28.8931H14.7241V28.8057Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 28.8931H10.8031V28.9806H14.7241V28.8931Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 28.9812H10.8031V29.0687H14.7241V28.9812Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 29.0687H10.8031V29.1561H14.7241V29.0687Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 29.1561H10.8031V29.2436H14.7241V29.1561Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 29.2436H10.8031V29.331H14.7241V29.2436Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 29.331H10.8031V29.4184H14.7241V29.331Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 29.4184H10.8031V29.5059H14.7241V29.4184Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 29.5066H10.8031V29.594H14.7241V29.5066Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 29.594H10.8031V29.6815H14.7241V29.594Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 29.6815H10.8031V29.7689H14.7241V29.6815Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 29.7689H10.8031V29.8563H14.7241V29.7689Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 29.8563H10.8031V29.9438H14.7241V29.8563Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 29.9438H10.8031V30.0312H14.7241V29.9438Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 30.0312H10.8031V30.1187H14.7241V30.0312Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 30.1194H10.8031V30.2068H14.7241V30.1194Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 30.2068H10.8031V30.2942H14.7241V30.2068Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 30.2942H10.8031V30.3817H14.7241V30.2942Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 30.3817H10.8031V30.4691H14.7241V30.3817Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 30.4691H10.8031V30.5566H14.7241V30.4691Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 30.5566H10.8031V30.644H14.7241V30.5566Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 30.644H10.8031V30.7314H14.7241V30.644Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 30.7321H10.8031V30.8196H14.7241V30.7321Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 30.8196H10.8031V30.907H14.7241V30.8196Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 30.907H10.8031V30.9945H14.7241V30.907Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 30.9944H10.8031V31.0819H14.7241V30.9944Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 31.0819H10.8031V31.1693H14.7241V31.0819Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 31.1693H10.8031V31.2568H14.7241V31.1693Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 31.2568H10.8031V31.3442H14.7241V31.2568Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 31.3449H10.8031V31.4323H14.7241V31.3449Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 31.4323H10.8031V31.5198H14.7241V31.4323Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 31.5198H10.8031V31.6072H14.7241V31.5198Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 31.6072H10.8031V31.6947H14.7241V31.6072Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 31.6947H10.8031V31.7821H14.7241V31.6947Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 31.7821H10.8031V31.8696H14.7241V31.7821Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 31.8696H10.8031V31.957H14.7241V31.8696Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 31.9577H10.8031V32.0451H14.7241V31.9577Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 32.0451H10.8031V32.1326H14.7241V32.0451Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 32.1326H10.8031V32.22H14.7241V32.1326Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 32.22H10.8031V32.3074H14.7241V32.22Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 32.3074H10.8031V32.3949H14.7241V32.3074Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 32.3949H10.8031V32.4823H14.7241V32.3949Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 32.4823H10.8031V32.5698H14.7241V32.4823Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 32.5705H10.8031V32.6579H14.7241V32.5705Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 32.6579H10.8031V32.7453H14.7241V32.6579Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 32.7453H10.8031V32.8328H14.7241V32.7453Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 32.8328H10.8031V32.9202H14.7241V32.8328Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 32.9202H10.8031V33.0077H14.7241V32.9202Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 33.0077H10.8031V33.0951H14.7241V33.0077Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 33.0958H10.8031V33.1832H14.7241V33.0958Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 33.1832H10.8031V33.2707H14.7241V33.1832Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 33.2707H10.8031V33.3581H14.7241V33.2707Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 33.3581H10.8031V33.4455H14.7241V33.3581Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 33.4456H10.8031V33.533H14.7241V33.4456Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 33.533H10.8031V33.6204H14.7241V33.533Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 33.6204H10.8031V33.7079H14.7241V33.6204Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 33.7086H10.8031V33.796H14.7241V33.7086Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 33.796H10.8031V33.8834H14.7241V33.796Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 33.8835H10.8031V33.9709H14.7241V33.8835Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 33.9709H10.8031V34.0583H14.7241V33.9709Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 34.0583H10.8031V34.1458H14.7241V34.0583Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 34.1458H10.8031V34.2332H14.7241V34.1458Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 34.2332H10.8031V34.3207H14.7241V34.2332Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 34.3213H10.8031V34.4088H14.7241V34.3213Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 34.4088H10.8031V34.4962H14.7241V34.4088Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 34.4962H10.8031V34.5837H14.7241V34.4962Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 34.5837H10.8031V34.6711H14.7241V34.5837Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 34.6711H10.8031V34.7585H14.7241V34.6711Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 34.7585H10.8031V34.846H14.7241V34.7585Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 34.846H10.8031V34.9334H14.7241V34.846Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 34.9341H10.8031V35.0216H14.7241V34.9341Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 35.0216H10.8031V35.109H14.7241V35.0216Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 35.109H10.8031V35.1964H14.7241V35.109Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 35.1964H10.8031V35.2839H14.7241V35.1964Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 35.2839H10.8031V35.3713H14.7241V35.2839Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 35.3713H10.8031V35.4588H14.7241V35.3713Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 35.4588H10.8031V35.5462H14.7241V35.4588Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 35.5469H10.8031V35.6343H14.7241V35.5469Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 35.6343H10.8031V35.7218H14.7241V35.6343Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 35.7218H10.8031V35.8092H14.7241V35.7218Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 35.8092H10.8031V35.8967H14.7241V35.8092Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 35.8967H10.8031V35.9841H14.7241V35.8967Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 35.9841H10.8031V36.0715H14.7241V35.9841Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 36.0715H10.8031V36.159H14.7241V36.0715Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 36.1597H10.8031V36.2471H14.7241V36.1597Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 36.2471H10.8031V36.3346H14.7241V36.2471Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 36.3346H10.8031V36.422H14.7241V36.3346Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 36.422H10.8031V36.5094H14.7241V36.422Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 36.5094H10.8031V36.5969H14.7241V36.5094Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 36.5969H10.8031V36.6843H14.7241V36.5969Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 36.685H10.8031V36.7724H14.7241V36.685Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 36.7724H10.8031V36.8599H14.7241V36.7724Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 36.8599H10.8031V36.9473H14.7241V36.8599Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 36.9473H10.8031V37.0348H14.7241V36.9473Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 37.0348H10.8031V37.1222H14.7241V37.0348Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 37.1222H10.8031V37.2097H14.7241V37.1222Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 37.2096H10.8031V37.2971H14.7241V37.2096Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 37.2978H10.8031V37.3852H14.7241V37.2978Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 37.3852H10.8031V37.4727H14.7241V37.3852Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 37.4727H10.8031V37.5601H14.7241V37.4727Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 37.5601H10.8031V37.6476H14.7241V37.5601Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 37.6476H10.8031V37.735H14.7241V37.6476Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 37.735H10.8031V37.8224H14.7241V37.735Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 37.8224H10.8031V37.9099H14.7241V37.8224Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 37.9106H10.8031V37.998H14.7241V37.9106Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 37.998H10.8031V38.0854H14.7241V37.998Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 38.0854H10.8031V38.1729H14.7241V38.0854Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 38.1729H10.8031V38.2603H14.7241V38.1729Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 38.2603H10.8031V38.3478H14.7241V38.2603Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 38.3478H10.8031V38.4352H14.7241V38.3478Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 38.4352H10.8031V38.5227H14.7241V38.4352Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 38.5233H10.8031V38.6108H14.7241V38.5233Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 38.6108H10.8031V38.6982H14.7241V38.6108Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 38.6982H10.8031V38.7857H14.7241V38.6982Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 38.7857H10.8031V38.8731H14.7241V38.7857Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 38.8731H10.8031V38.9605H14.7241V38.8731Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 38.9605H10.8031V39.048H14.7241V38.9605Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 39.048H10.8031V39.1354H14.7241V39.048Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7241 39.1361H10.8031V39.2236H14.7241V39.1361Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_120_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 27,
    width: 5,
    height: 13
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1023 34.2642C35.1023 32.912 35.1023 31.559 35.1037 30.2068C35.1037 30.1476 35.092 30.1008 35.0494 30.056C34.8599 29.8543 34.6738 29.6491 34.4863 29.4453C34.3071 29.2505 34.1265 29.057 33.9473 28.8628C33.6039 28.489 33.2606 28.1165 32.9186 27.7412C32.8753 27.6937 32.83 27.6744 32.7655 27.6751C32.2745 27.6772 31.7828 27.6765 31.2918 27.6765C31.276 27.6765 31.2602 27.6779 31.2451 27.6765C31.2005 27.6731 31.182 27.693 31.1854 27.7364C31.1875 27.755 31.1854 27.7736 31.1854 27.7929V39.059C31.1854 39.0934 31.1854 39.1272 31.1854 39.1616C31.1868 39.2366 31.1875 39.2366 31.2651 39.238H32.7105C32.8355 39.238 32.8266 39.2504 32.8266 39.123V36.0936C32.8266 36.075 32.8266 36.0564 32.8266 36.0371C32.8287 35.9662 32.8314 35.9621 32.9008 35.9614C33.0443 35.96 33.1871 35.9614 33.3299 35.9614C33.416 35.9614 33.459 36.0036 33.459 36.0881V39.0989C33.459 39.1237 33.459 39.1485 33.459 39.1733C33.459 39.2036 33.4728 39.2208 33.503 39.2215C33.5284 39.2215 33.5531 39.2215 33.5778 39.2215H34.9766C35.1153 39.2215 35.1023 39.2339 35.1023 39.0962V34.2621V34.2642ZM33.459 34.1988C33.459 34.2146 33.459 34.2305 33.459 34.2456C33.4563 34.3145 33.4542 34.3179 33.3828 34.3186C33.2214 34.32 33.0601 34.32 32.898 34.3186C32.8321 34.3186 32.83 34.3138 32.8266 34.2497C32.8266 34.2373 32.8266 34.225 32.8266 34.2126V29.5321C32.8266 29.5107 32.8211 29.4887 32.8362 29.4632C32.8781 29.4687 32.9001 29.4956 32.9234 29.5197C33.08 29.6883 33.2338 29.8591 33.3924 30.0257C33.4439 30.0794 33.4611 30.1366 33.4604 30.2102C33.4583 31.5398 33.459 32.8693 33.459 34.1995V34.1988Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_120_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 29.4625H32.8218V29.4983H33.4611V29.4625Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 29.4983H32.8218V29.561H33.4611V29.4983Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 29.561H32.8218V29.6236H33.4611V29.561Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 29.6243H32.8218V29.687H33.4611V29.6243Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 29.687H32.8218V29.7496H33.4611V29.687Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 29.7496H32.8218V29.8123H33.4611V29.7496Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 29.8123H32.8218V29.8749H33.4611V29.8123Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 29.8756H32.8218V29.9383H33.4611V29.8756Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 29.9383H32.8218V30.0009H33.4611V29.9383Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.0009H32.8218V30.0636H33.4611V30.0009Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.0643H32.8218V30.1269H33.4611V30.0643Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.1269H32.8218V30.1896H33.4611V30.1269Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.1896H32.8218V30.2522H33.4611V30.1896Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.2522H32.8218V30.3149H33.4611V30.2522Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.3156H32.8218V30.3782H33.4611V30.3156Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.3782H32.8218V30.4409H33.4611V30.3782Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.4409H32.8218V30.5035H33.4611V30.4409Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.5042H32.8218V30.5669H33.4611V30.5042Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.5669H32.8218V30.6295H33.4611V30.5669Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.6295H32.8218V30.6922H33.4611V30.6295Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.6922H32.8218V30.7549H33.4611V30.6922Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.7555H32.8218V30.8182H33.4611V30.7555Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.8182H32.8218V30.8809H33.4611V30.8182Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.8809H32.8218V30.9435H33.4611V30.8809Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 30.9435H32.8218V31.0062H33.4611V30.9435Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.0069H32.8218V31.0695H33.4611V31.0069Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.0695H32.8218V31.1322H33.4611V31.0695Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.1322H32.8218V31.1948H33.4611V31.1322Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.1955H32.8218V31.2582H33.4611V31.1955Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.2582H32.8218V31.3208H33.4611V31.2582Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.3208H32.8218V31.3835H33.4611V31.3208Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.3835H32.8218V31.4461H33.4611V31.3835Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.4468H32.8218V31.5095H33.4611V31.4468Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.5095H32.8218V31.5721H33.4611V31.5095Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.5721H32.8218V31.6348H33.4611V31.5721Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.6355H32.8218V31.6981H33.4611V31.6355Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.6981H32.8218V31.7608H33.4611V31.6981Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.7608H32.8218V31.8234H33.4611V31.7608Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.8234H32.8218V31.8861H33.4611V31.8234Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.8868H32.8218V31.9494H33.4611V31.8868Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 31.9494H32.8218V32.0121H33.4611V31.9494Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.0121H32.8218V32.0747H33.4611V32.0121Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.0747H32.8218V32.1374H33.4611V32.0747Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.1381H32.8218V32.2007H33.4611V32.1381Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.2007H32.8218V32.2634H33.4611V32.2007Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.2634H32.8218V32.326H33.4611V32.2634Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.3267H32.8218V32.3894H33.4611V32.3267Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.3894H32.8218V32.452H33.4611V32.3894Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.452H32.8218V32.5147H33.4611V32.452Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.5147H32.8218V32.5773H33.4611V32.5147Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.578H32.8218V32.6407H33.4611V32.578Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.6407H32.8218V32.7033H33.4611V32.6407Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.7033H32.8218V32.766H33.4611V32.7033Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.7667H32.8218V32.8293H33.4611V32.7667Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.8293H32.8218V32.892H33.4611V32.8293Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.892H32.8218V32.9546H33.4611V32.892Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 32.9546H32.8218V33.0173H33.4611V32.9546Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.018H32.8218V33.0806H33.4611V33.018Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.0807H32.8218V33.1433H33.4611V33.0807Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.1433H32.8218V33.206H33.4611V33.1433Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.206H32.8218V33.2686H33.4611V33.206Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.2693H32.8218V33.332H33.4611V33.2693Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.3319H32.8218V33.3946H33.4611V33.3319Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.3946H32.8218V33.4573H33.4611V33.3946Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.458H32.8218V33.5206H33.4611V33.458Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.5206H32.8218V33.5833H33.4611V33.5206Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.5833H32.8218V33.6459H33.4611V33.5833Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.6459H32.8218V33.7086H33.4611V33.6459Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.7093H32.8218V33.7719H33.4611V33.7093Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.7719H32.8218V33.8346H33.4611V33.7719Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.8346H32.8218V33.8972H33.4611V33.8346Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.8979H32.8218V33.9606H33.4611V33.8979Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 33.9606H32.8218V34.0232H33.4611V33.9606Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 34.0232H32.8218V34.0859H33.4611V34.0232Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 34.0859H32.8218V34.1485H33.4611V34.0859Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 34.1492H32.8218V34.2119H33.4611V34.1492Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 34.2119H32.8218V34.2745H33.4611V34.2119Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4611 34.2745H32.8218V34.32H33.4611V34.2745Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 27.6738H31.1813V27.6759H35.1154V27.6738Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 27.6758H31.1813V27.7385H35.1154V27.6758Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 27.7385H31.1813V27.8011H35.1154V27.7385Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 27.8018H31.1813V27.8645H35.1154V27.8018Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 27.8645H31.1813V27.9271H35.1154V27.8645Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 27.9271H31.1813V27.9898H35.1154V27.9271Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 27.9898H31.1813V28.0524H35.1154V27.9898Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.0531H31.1813V28.1158H35.1154V28.0531Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.1158H31.1813V28.1784H35.1154V28.1158Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.1784H31.1813V28.2411H35.1154V28.1784Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.2418H31.1813V28.3044H35.1154V28.2418Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.3044H31.1813V28.3671H35.1154V28.3044Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.3671H31.1813V28.4297H35.1154V28.3671Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.4297H31.1813V28.4924H35.1154V28.4297Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.4931H31.1813V28.5557H35.1154V28.4931Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.5557H31.1813V28.6184H35.1154V28.5557Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.6184H31.1813V28.6811H35.1154V28.6184Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.6811H31.1813V28.7437H35.1154V28.6811Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.7444H31.1813V28.807H35.1154V28.7444Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.8071H31.1813V28.8697H35.1154V28.8071Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.8697H31.1813V28.9324H35.1154V28.8697Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.933H31.1813V28.9957H35.1154V28.933Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 28.9957H31.1813V29.0584H35.1154V28.9957Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.0584H31.1813V29.121H35.1154V29.0584Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.121H31.1813V29.1837H35.1154V29.121Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.1844H31.1813V29.247H35.1154V29.1844Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.247H31.1813V29.3097H35.1154V29.247Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.3097H31.1813V29.3723H35.1154V29.3097Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.373H31.1813V29.4357H35.1154V29.373Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.4357H31.1813V29.4983H35.1154V29.4357Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.4983H31.1813V29.561H35.1154V29.4983Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.561H31.1813V29.6236H35.1154V29.561Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.6243H31.1813V29.687H35.1154V29.6243Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.687H31.1813V29.7496H35.1154V29.687Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.7496H31.1813V29.8123H35.1154V29.7496Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.8123H31.1813V29.8749H35.1154V29.8123Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.8756H31.1813V29.9383H35.1154V29.8756Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 29.9383H31.1813V30.0009H35.1154V29.9383Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.0009H31.1813V30.0636H35.1154V30.0009Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.0643H31.1813V30.1269H35.1154V30.0643Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.1269H31.1813V30.1896H35.1154V30.1269Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.1896H31.1813V30.2522H35.1154V30.1896Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.2522H31.1813V30.3149H35.1154V30.2522Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.3156H31.1813V30.3782H35.1154V30.3156Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.3782H31.1813V30.4409H35.1154V30.3782Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.4409H31.1813V30.5035H35.1154V30.4409Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.5042H31.1813V30.5669H35.1154V30.5042Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.5669H31.1813V30.6295H35.1154V30.5669Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.6295H31.1813V30.6922H35.1154V30.6295Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.6922H31.1813V30.7549H35.1154V30.6922Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.7555H31.1813V30.8182H35.1154V30.7555Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.8182H31.1813V30.8809H35.1154V30.8182Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.8809H31.1813V30.9435H35.1154V30.8809Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 30.9435H31.1813V31.0062H35.1154V30.9435Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.0069H31.1813V31.0695H35.1154V31.0069Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.0695H31.1813V31.1322H35.1154V31.0695Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.1322H31.1813V31.1948H35.1154V31.1322Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.1955H31.1813V31.2582H35.1154V31.1955Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.2582H31.1813V31.3208H35.1154V31.2582Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.3208H31.1813V31.3835H35.1154V31.3208Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.3835H31.1813V31.4461H35.1154V31.3835Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.4468H31.1813V31.5095H35.1154V31.4468Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.5095H31.1813V31.5721H35.1154V31.5095Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.5721H31.1813V31.6348H35.1154V31.5721Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.6355H31.1813V31.6981H35.1154V31.6355Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.6981H31.1813V31.7608H35.1154V31.6981Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.7608H31.1813V31.8234H35.1154V31.7608Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.8234H31.1813V31.8861H35.1154V31.8234Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.8868H31.1813V31.9494H35.1154V31.8868Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 31.9494H31.1813V32.0121H35.1154V31.9494Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.0121H31.1813V32.0747H35.1154V32.0121Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.0747H31.1813V32.1374H35.1154V32.0747Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.1381H31.1813V32.2007H35.1154V32.1381Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.2007H31.1813V32.2634H35.1154V32.2007Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.2634H31.1813V32.326H35.1154V32.2634Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.3267H31.1813V32.3894H35.1154V32.3267Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.3894H31.1813V32.452H35.1154V32.3894Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.452H31.1813V32.5147H35.1154V32.452Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.5147H31.1813V32.5773H35.1154V32.5147Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.578H31.1813V32.6407H35.1154V32.578Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.6407H31.1813V32.7033H35.1154V32.6407Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.7033H31.1813V32.766H35.1154V32.7033Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.7667H31.1813V32.8293H35.1154V32.7667Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.8293H31.1813V32.892H35.1154V32.8293Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.892H31.1813V32.9546H35.1154V32.892Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 32.9546H31.1813V33.0173H35.1154V32.9546Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.018H31.1813V33.0806H35.1154V33.018Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.0807H31.1813V33.1433H35.1154V33.0807Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.1433H31.1813V33.206H35.1154V33.1433Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.206H31.1813V33.2686H35.1154V33.206Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.2693H31.1813V33.332H35.1154V33.2693Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.3319H31.1813V33.3946H35.1154V33.3319Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.3946H31.1813V33.4573H35.1154V33.3946Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.458H31.1813V33.5206H35.1154V33.458Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.5206H31.1813V33.5833H35.1154V33.5206Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.5833H31.1813V33.6459H35.1154V33.5833Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.6459H31.1813V33.7086H35.1154V33.6459Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.7093H31.1813V33.7719H35.1154V33.7093Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.7719H31.1813V33.8346H35.1154V33.7719Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.8346H31.1813V33.8972H35.1154V33.8346Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.8979H31.1813V33.9606H35.1154V33.8979Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 33.9606H31.1813V34.0232H35.1154V33.9606Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.0232H31.1813V34.0859H35.1154V34.0232Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.0859H31.1813V34.1485H35.1154V34.0859Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.1492H31.1813V34.2119H35.1154V34.1492Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.2119H31.1813V34.2745H35.1154V34.2119Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.2745H31.1813V34.3372H35.1154V34.2745Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.3372H31.1813V34.3998H35.1154V34.3372Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.4005H31.1813V34.4632H35.1154V34.4005Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.4632H31.1813V34.5258H35.1154V34.4632Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.5258H31.1813V34.5885H35.1154V34.5258Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.5892H31.1813V34.6518H35.1154V34.5892Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.6518H31.1813V34.7145H35.1154V34.6518Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.7145H31.1813V34.7771H35.1154V34.7145Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.7771H31.1813V34.8398H35.1154V34.7771Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.8405H31.1813V34.9031H35.1154V34.8405Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.9031H31.1813V34.9658H35.1154V34.9031Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 34.9658H31.1813V35.0285H35.1154V34.9658Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.0291H31.1813V35.0918H35.1154V35.0291Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.0918H31.1813V35.1544H35.1154V35.0918Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.1544H31.1813V35.2171H35.1154V35.1544Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.2171H31.1813V35.2798H35.1154V35.2171Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.2804H31.1813V35.3431H35.1154V35.2804Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.3431H31.1813V35.4057H35.1154V35.3431Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.4058H31.1813V35.4684H35.1154V35.4058Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.4684H31.1813V35.5311H35.1154V35.4684Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.5317H31.1813V35.5944H35.1154V35.5317Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.5944H31.1813V35.6571H35.1154V35.5944Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.6571H31.1813V35.7197H35.1154V35.6571Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.7204H31.1813V35.7831H35.1154V35.7204Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.7831H31.1813V35.8457H35.1154V35.7831Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.8457H31.1813V35.9084H35.1154V35.8457Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.9084H31.1813V35.971H35.1154V35.9084Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 35.9717H31.1813V36.0344H35.1154V35.9717Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.0344H31.1813V36.097H35.1154V36.0344Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.097H31.1813V36.1597H35.1154V36.097Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.1604H31.1813V36.223H35.1154V36.1604Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.223H31.1813V36.2857H35.1154V36.223Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.2857H31.1813V36.3483H35.1154V36.2857Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.3483H31.1813V36.411H35.1154V36.3483Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.4117H31.1813V36.4743H35.1154V36.4117Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.4743H31.1813V36.537H35.1154V36.4743Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.537H31.1813V36.5996H35.1154V36.537Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.5996H31.1813V36.6623H35.1154V36.5996Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.663H31.1813V36.7256H35.1154V36.663Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.7256H31.1813V36.7883H35.1154V36.7256Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.7883H31.1813V36.8509H35.1154V36.7883Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.8516H31.1813V36.9143H35.1154V36.8516Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.9143H31.1813V36.9769H35.1154V36.9143Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 36.9769H31.1813V37.0396H35.1154V36.9769Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.0396H31.1813V37.1022H35.1154V37.0396Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.1029H31.1813V37.1656H35.1154V37.1029Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.1656H31.1813V37.2283H35.1154V37.1656Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.2282H31.1813V37.2909H35.1154V37.2282Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.2916H31.1813V37.3542H35.1154V37.2916Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.3542H31.1813V37.4169H35.1154V37.3542Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.4169H31.1813V37.4796H35.1154V37.4169Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.4796H31.1813V37.5422H35.1154V37.4796Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.5429H31.1813V37.6055H35.1154V37.5429Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.6056H31.1813V37.6682H35.1154V37.6056Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.6682H31.1813V37.7309H35.1154V37.6682Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.7309H31.1813V37.7935H35.1154V37.7309Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.7942H31.1813V37.8569H35.1154V37.7942Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.8569H31.1813V37.9195H35.1154V37.8569Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.9195H31.1813V37.9822H35.1154V37.9195Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 37.9829H31.1813V38.0455H35.1154V37.9829Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.0455H31.1813V38.1082H35.1154V38.0455Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.1082H31.1813V38.1708H35.1154V38.1082Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.1708H31.1813V38.2335H35.1154V38.1708Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.2342H31.1813V38.2968H35.1154V38.2342Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.2968H31.1813V38.3595H35.1154V38.2968Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.3595H31.1813V38.4221H35.1154V38.3595Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.4228H31.1813V38.4855H35.1154V38.4228Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.4855H31.1813V38.5481H35.1154V38.4855Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.5481H31.1813V38.6108H35.1154V38.5481Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.6108H31.1813V38.6734H35.1154V38.6108Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.6741H31.1813V38.7368H35.1154V38.6741Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.7368H31.1813V38.7994H35.1154V38.7368Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.7994H31.1813V38.8621H35.1154V38.7994Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.8621H31.1813V38.9247H35.1154V38.8621Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.9254H31.1813V38.9881H35.1154V38.9254Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 38.9881H31.1813V39.0507H35.1154V38.9881Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 39.0507H31.1813V39.1134H35.1154V39.0507Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 39.1141H31.1813V39.1767H35.1154V39.1141Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1154 39.1767H31.1813V39.2394H35.1154V39.1767Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_120_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 20,
    width: 2,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.338 29.9527C15.338 26.9047 15.338 23.8573 15.338 20.8093C15.338 20.6709 15.3277 20.684 15.463 20.684C15.9293 20.684 16.3955 20.684 16.8618 20.684C16.8803 20.684 16.8989 20.6854 16.9174 20.684C16.9682 20.6799 16.984 20.7053 16.9799 20.7515C16.9785 20.7639 16.9799 20.7762 16.9799 20.7886C16.9799 26.8902 16.9799 32.9925 16.9799 39.0941C16.9799 39.18 16.9375 39.2229 16.8529 39.2229C16.3866 39.2229 15.9203 39.2229 15.4541 39.2229C15.4321 39.2229 15.4108 39.2229 15.3888 39.2229C15.3531 39.2236 15.3387 39.2043 15.3387 39.1705C15.3387 39.1423 15.3387 39.1148 15.3387 39.0865C15.3387 36.0419 15.3387 32.9973 15.3387 29.9527H15.338Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_120_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9846 20.6715H15.327V20.6839H16.9846V20.6715Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9846 20.6833H15.327V20.7838H16.9846V20.6833Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 20.7838H15.327V20.8843H16.9847V20.7838Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 20.885H15.327V20.9855H16.9847V20.885Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 20.9855H15.327V21.0861H16.9847V20.9855Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 21.0868H15.327V21.1873H16.9847V21.0868Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 21.1873H15.327V21.2878H16.9847V21.1873Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 21.2878H15.327V21.3883H16.9847V21.2878Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 21.389H15.327V21.4895H16.9847V21.389Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 21.4895H15.327V21.5901H16.9847V21.4895Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 21.5901H15.327V21.6906H16.9847V21.5901Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 21.6913H15.327V21.7918H16.9847V21.6913Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 21.7918H15.327V21.8923H16.9847V21.7918Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 21.8923H15.327V21.9928H16.9847V21.8923Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 21.9935H15.327V22.0941H16.9847V21.9935Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 22.0941H15.327V22.1946H16.9847V22.0941Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 22.1946H15.327V22.2951H16.9847V22.1946Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 22.2958H15.327V22.3963H16.9847V22.2958Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 22.3963H15.327V22.4968H16.9847V22.3963Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 22.4968H15.327V22.5974H16.9847V22.4968Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 22.598H15.327V22.6986H16.9847V22.598Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 22.6986H15.327V22.7991H16.9847V22.6986Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 22.7991H15.327V22.8996H16.9847V22.7991Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 22.9003H15.327V23.0008H16.9847V22.9003Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 23.0008H15.327V23.1013H16.9847V23.0008Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 23.1013H15.327V23.2019H16.9847V23.1013Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 23.2026H15.327V23.3031H16.9847V23.2026Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 23.3031H15.327V23.4036H16.9847V23.3031Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 23.4036H15.327V23.5041H16.9847V23.4036Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 23.5048H15.327V23.6053H16.9847V23.5048Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 23.6053H15.327V23.7059H16.9847V23.6053Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 23.7059H15.327V23.8064H16.9847V23.7059Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 23.8071H15.327V23.9076H16.9847V23.8071Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 23.9076H15.327V24.0081H16.9847V23.9076Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 24.0088H15.327V24.1093H16.9847V24.0088Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 24.1093H15.327V24.2099H16.9847V24.1093Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 24.2099H15.327V24.3104H16.9847V24.2099Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 24.3111H15.327V24.4116H16.9847V24.3111Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 24.4116H15.327V24.5121H16.9847V24.4116Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 24.5121H15.327V24.6126H16.9847V24.5121Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 24.6133H15.327V24.7138H16.9847V24.6133Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 24.7138H15.327V24.8144H16.9847V24.7138Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 24.8144H15.327V24.9149H16.9847V24.8144Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 24.9156H15.327V25.0161H16.9847V24.9156Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 25.0161H15.327V25.1166H16.9847V25.0161Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 25.1166H15.327V25.2171H16.9847V25.1166Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 25.2178H15.327V25.3184H16.9847V25.2178Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 25.3184H15.327V25.4189H16.9847V25.3184Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 25.4189H15.327V25.5194H16.9847V25.4189Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 25.5201H15.327V25.6206H16.9847V25.5201Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 25.6206H15.327V25.7211H16.9847V25.6206Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 25.7211H15.327V25.8217H16.9847V25.7211Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 25.8223H15.327V25.9229H16.9847V25.8223Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 25.9229H15.327V26.0234H16.9847V25.9229Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 26.0234H15.327V26.1239H16.9847V26.0234Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 26.1246H15.327V26.2251H16.9847V26.1246Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 26.2251H15.327V26.3257H16.9847V26.2251Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 26.3256H15.327V26.4262H16.9847V26.3256Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 26.4269H15.327V26.5274H16.9847V26.4269Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 26.5274H15.327V26.6279H16.9847V26.5274Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 26.6279H15.327V26.7284H16.9847V26.6279Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 26.7291H15.327V26.8296H16.9847V26.7291Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 26.8296H15.327V26.9302H16.9847V26.8296Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 26.9309H15.327V27.0314H16.9847V26.9309Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 27.0314H15.327V27.1319H16.9847V27.0314Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 27.1319H15.327V27.2324H16.9847V27.1319Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 27.2331H15.327V27.3336H16.9847V27.2331Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 27.3336H15.327V27.4342H16.9847V27.3336Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 27.4342H15.327V27.5347H16.9847V27.4342Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 27.5354H15.327V27.6359H16.9847V27.5354Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 27.6359H15.327V27.7364H16.9847V27.6359Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 27.7364H15.327V27.8369H16.9847V27.7364Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 27.8376H15.327V27.9381H16.9847V27.8376Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 27.9381H15.327V28.0387H16.9847V27.9381Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 28.0387H15.327V28.1392H16.9847V28.0387Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 28.1399H15.327V28.2404H16.9847V28.1399Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 28.2404H15.327V28.3409H16.9847V28.2404Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 28.3409H15.327V28.4414H16.9847V28.3409Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 28.4421H15.327V28.5427H16.9847V28.4421Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 28.5427H15.327V28.6432H16.9847V28.5427Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 28.6432H15.327V28.7437H16.9847V28.6432Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 28.7444H15.327V28.8449H16.9847V28.7444Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 28.8449H15.327V28.9454H16.9847V28.8449Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 28.9454H15.327V29.046H16.9847V28.9454Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 29.0467H15.327V29.1472H16.9847V29.0467Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 29.1472H15.327V29.2477H16.9847V29.1472Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 29.2477H15.327V29.3482H16.9847V29.2477Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 29.3489H15.327V29.4494H16.9847V29.3489Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 29.4494H15.327V29.55H16.9847V29.4494Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 29.55H15.327V29.6505H16.9847V29.55Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 29.6512H15.327V29.7517H16.9847V29.6512Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 29.7517H15.327V29.8522H16.9847V29.7517Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 29.8529H15.327V29.9534H16.9847V29.8529Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 29.9534H15.327V30.0539H16.9847V29.9534Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 30.0539H15.327V30.1545H16.9847V30.0539Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 30.1552H15.327V30.2557H16.9847V30.1552Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 30.2557H15.327V30.3562H16.9847V30.2557Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 30.3562H15.327V30.4567H16.9847V30.3562Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 30.4574H15.327V30.5579H16.9847V30.4574Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 30.5579H15.327V30.6585H16.9847V30.5579Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 30.6585H15.327V30.759H16.9847V30.6585Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 30.7597H15.327V30.8602H16.9847V30.7597Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 30.8602H15.327V30.9607H16.9847V30.8602Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 30.9607H15.327V31.0612H16.9847V30.9607Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 31.0619H15.327V31.1625H16.9847V31.0619Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 31.1625H15.327V31.263H16.9847V31.1625Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 31.263H15.327V31.3635H16.9847V31.263Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 31.3642H15.327V31.4647H16.9847V31.3642Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 31.4647H15.327V31.5652H16.9847V31.4647Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 31.5652H15.327V31.6658H16.9847V31.5652Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 31.6665H15.327V31.767H16.9847V31.6665Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 31.767H15.327V31.8675H16.9847V31.767Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 31.8675H15.327V31.968H16.9847V31.8675Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 31.9687H15.327V32.0692H16.9847V31.9687Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 32.0692H15.327V32.1698H16.9847V32.0692Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 32.1697H15.327V32.2703H16.9847V32.1697Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 32.271H15.327V32.3715H16.9847V32.271Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 32.3715H15.327V32.472H16.9847V32.3715Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 32.472H15.327V32.5725H16.9847V32.472Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 32.5732H15.327V32.6737H16.9847V32.5732Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 32.6737H15.327V32.7743H16.9847V32.6737Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 32.7743H15.327V32.8748H16.9847V32.7743Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 32.8755H15.327V32.976H16.9847V32.8755Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 32.976H15.327V33.0765H16.9847V32.976Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 33.0772H15.327V33.1777H16.9847V33.0772Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 33.1777H15.327V33.2782H16.9847V33.1777Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 33.2783H15.327V33.3788H16.9847V33.2783Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 33.3795H15.327V33.48H16.9847V33.3795Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 33.48H15.327V33.5805H16.9847V33.48Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 33.5805H15.327V33.681H16.9847V33.5805Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 33.6817H15.327V33.7822H16.9847V33.6817Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 33.7822H15.327V33.8828H16.9847V33.7822Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 33.8828H15.327V33.9833H16.9847V33.8828Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 33.984H15.327V34.0845H16.9847V33.984Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 34.0845H15.327V34.185H16.9847V34.0845Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 34.185H15.327V34.2855H16.9847V34.185Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 34.2862H15.327V34.3868H16.9847V34.2862Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 34.3868H15.327V34.4873H16.9847V34.3868Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 34.4873H15.327V34.5878H16.9847V34.4873Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 34.5885H15.327V34.689H16.9847V34.5885Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 34.689H15.327V34.7895H16.9847V34.689Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 34.7895H15.327V34.8901H16.9847V34.7895Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 34.8908H15.327V34.9913H16.9847V34.8908Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 34.9913H15.327V35.0918H16.9847V34.9913Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 35.0918H15.327V35.1923H16.9847V35.0918Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 35.193H15.327V35.2935H16.9847V35.193Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 35.2935H15.327V35.3941H16.9847V35.2935Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 35.3941H15.327V35.4946H16.9847V35.3941Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 35.4953H15.327V35.5958H16.9847V35.4953Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 35.5958H15.327V35.6963H16.9847V35.5958Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 35.6963H15.327V35.7968H16.9847V35.6963Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 35.7975H15.327V35.898H16.9847V35.7975Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 35.898H15.327V35.9986H16.9847V35.898Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 35.9993H15.327V36.0998H16.9847V35.9993Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 36.0998H15.327V36.2003H16.9847V36.0998Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 36.2003H15.327V36.3008H16.9847V36.2003Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 36.3015H15.327V36.402H16.9847V36.3015Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 36.402H15.327V36.5026H16.9847V36.402Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 36.5025H15.327V36.6031H16.9847V36.5025Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 36.6038H15.327V36.7043H16.9847V36.6038Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 36.7043H15.327V36.8048H16.9847V36.7043Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 36.8048H15.327V36.9053H16.9847V36.8048Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 36.906H15.327V37.0065H16.9847V36.906Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 37.0065H15.327V37.1071H16.9847V37.0065Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 37.1071H15.327V37.2076H16.9847V37.1071Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 37.2083H15.327V37.3088H16.9847V37.2083Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 37.3088H15.327V37.4093H16.9847V37.3088Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 37.4093H15.327V37.5098H16.9847V37.4093Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 37.5105H15.327V37.6111H16.9847V37.5105Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 37.6111H15.327V37.7116H16.9847V37.6111Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 37.7116H15.327V37.8121H16.9847V37.7116Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 37.8128H15.327V37.9133H16.9847V37.8128Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 37.9133H15.327V38.0138H16.9847V37.9133Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 38.0138H15.327V38.1144H16.9847V38.0138Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 38.115H15.327V38.2156H16.9847V38.115Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 38.2156H15.327V38.3161H16.9847V38.2156Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 38.3161H15.327V38.4166H16.9847V38.3161Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 38.4173H15.327V38.5178H16.9847V38.4173Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 38.5178H15.327V38.6184H16.9847V38.5178Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 38.6184H15.327V38.7189H16.9847V38.6184Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 38.7196H15.327V38.8201H16.9847V38.7196Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 38.8201H15.327V38.9206H16.9847V38.8201Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 38.9213H15.327V39.0218H16.9847V38.9213Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 39.0218H15.327V39.1223H16.9847V39.0218Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9847 39.1223H15.327V39.2229H16.9847V39.1223Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_120_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 30,
    width: 4,
    height: 10
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90178 39.1003V30.2274C7.90178 30.2061 7.90178 30.1841 7.90178 30.162C7.90384 30.1283 7.88942 30.1097 7.85371 30.1104C7.83792 30.1104 7.82213 30.1104 7.80702 30.1104C7.31878 30.1104 6.83054 30.1118 6.34299 30.109C6.28531 30.109 6.24411 30.1262 6.20291 30.1655C5.91038 30.445 5.6151 30.7211 5.32119 31C4.90163 31.3979 4.48343 31.7979 4.06249 32.1959C4.01785 32.2379 4 32.2792 4 32.3412C4.00206 34.5974 4.00137 36.8537 4.00137 39.1106C4.00137 39.132 4.00137 39.1547 4.00137 39.176C4.00137 39.2056 4.01442 39.2229 4.04532 39.2236C4.06661 39.2236 4.08927 39.2236 4.11056 39.2236C4.583 39.2236 5.05613 39.2236 5.52858 39.2236C5.65699 39.2236 5.64394 39.2256 5.64394 39.1058V36.0956C5.64394 36.077 5.64394 36.0585 5.64394 36.0392C5.646 35.9676 5.64806 35.9634 5.71742 35.9634C5.87604 35.9614 6.03467 35.9614 6.19329 35.9634C6.26334 35.9634 6.26746 35.9696 6.2702 36.0371C6.2702 36.0557 6.2702 36.0743 6.2702 36.0936V39.1044C6.2702 39.1258 6.2702 39.1478 6.2702 39.1698C6.26814 39.2105 6.29012 39.2249 6.3272 39.2242C6.34574 39.2242 6.36428 39.2242 6.38351 39.2242H7.7823C7.91208 39.2242 7.90178 39.2332 7.90178 39.1017V39.1003ZM6.2702 31.7752V34.1974C6.2702 34.2188 6.2702 34.2408 6.2702 34.2621C6.27158 34.3021 6.25235 34.3193 6.21389 34.3186H6.02711C5.92136 34.3186 5.8163 34.3172 5.71055 34.3186C5.66317 34.32 5.63913 34.3028 5.64325 34.2539C5.64463 34.2415 5.64325 34.2284 5.64325 34.2167C5.64325 33.5867 5.64325 32.9574 5.64119 32.3281C5.64119 32.2627 5.65973 32.2159 5.70918 32.1746C5.87329 32.0355 6.02437 31.884 6.17887 31.7346C6.19398 31.7195 6.20909 31.7022 6.22694 31.6912C6.24548 31.6795 6.26402 31.6857 6.26746 31.7098C6.2702 31.7312 6.26883 31.7539 6.26883 31.7752H6.2702Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_120_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 31.6795H5.6391V31.694H6.27154V31.6795Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 31.694H5.6391V31.7436H6.27154V31.694Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 31.7436H5.6391V31.7931H6.27154V31.7436Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 31.7931H5.6391V31.8427H6.27154V31.7931Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 31.8427H5.6391V31.8923H6.27154V31.8427Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 31.8923H5.6391V31.9418H6.27154V31.8923Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 31.9418H5.6391V31.9914H6.27154V31.9418Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 31.9914H5.6391V32.041H6.27154V31.9914Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.041H5.6391V32.0906H6.27154V32.041Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.0906H5.6391V32.1401H6.27154V32.0906Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.1401H5.6391V32.1897H6.27154V32.1401Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.1897H5.6391V32.2393H6.27154V32.1897Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.2386H5.6391V32.2882H6.27154V32.2386Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.2882H5.6391V32.3377H6.27154V32.2882Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.3377H5.6391V32.3873H6.27154V32.3377Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.3873H5.6391V32.4369H6.27154V32.3873Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.4369H5.6391V32.4865H6.27154V32.4369Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.4865H5.6391V32.536H6.27154V32.4865Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.536H5.6391V32.5856H6.27154V32.536Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.5856H5.6391V32.6352H6.27154V32.5856Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.6352H5.6391V32.6848H6.27154V32.6352Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.6848H5.6391V32.7343H6.27154V32.6848Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.7343H5.6391V32.7839H6.27154V32.7343Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.7839H5.6391V32.8335H6.27154V32.7839Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.8335H5.6391V32.883H6.27154V32.8335Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.883H5.6391V32.9326H6.27154V32.883Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.9326H5.6391V32.9822H6.27154V32.9326Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 32.9822H5.6391V33.0318H6.27154V32.9822Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.0318H5.6391V33.0813H6.27154V33.0318Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.0813H5.6391V33.1309H6.27154V33.0813Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.1309H5.6391V33.1805H6.27154V33.1309Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.1798H5.6391V33.2294H6.27154V33.1798Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.2294H5.6391V33.2789H6.27154V33.2294Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.2789H5.6391V33.3285H6.27154V33.2789Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.3285H5.6391V33.3781H6.27154V33.3285Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.3781H5.6391V33.4277H6.27154V33.3781Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.4277H5.6391V33.4772H6.27154V33.4277Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.4772H5.6391V33.5268H6.27154V33.4772Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.5268H5.6391V33.5764H6.27154V33.5268Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.5764H5.6391V33.6259H6.27154V33.5764Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.6259H5.6391V33.6755H6.27154V33.6259Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.6755H5.6391V33.7251H6.27154V33.6755Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.7251H5.6391V33.7747H6.27154V33.7251Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.7747H5.6391V33.8242H6.27154V33.7747Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.8242H5.6391V33.8738H6.27154V33.8242Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.8738H5.6391V33.9234H6.27154V33.8738Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.9234H5.6391V33.973H6.27154V33.9234Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 33.973H5.6391V34.0225H6.27154V33.973Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 34.0225H5.6391V34.0721H6.27154V34.0225Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 34.0714H5.6391V34.121H6.27154V34.0714Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 34.121H5.6391V34.1706H6.27154V34.121Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 34.1706H5.6391V34.2201H6.27154V34.1706Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 34.2201H5.6391V34.2697H6.27154V34.2201Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 34.2697H5.6391V34.3193H6.27154V34.2697Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27154 34.3193H5.6391V34.3207H6.27154V34.3193Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.109H4V30.1586H7.91208V30.109Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.1586H4V30.2082H7.91208V30.1586Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.2082H4V30.2578H7.91208V30.2082Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.2578H4V30.3073H7.91208V30.2578Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.3073H4V30.3569H7.91208V30.3073Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.3562H4V30.4058H7.91208V30.3562Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.4058H4V30.4553H7.91208V30.4058Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.4553H4V30.5049H7.91208V30.4553Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.5049H4V30.5545H7.91208V30.5049Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.5545H4V30.6041H7.91208V30.5545Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.6041H4V30.6536H7.91208V30.6041Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.6536H4V30.7032H7.91208V30.6536Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.7032H4V30.7528H7.91208V30.7032Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.7528H4V30.8024H7.91208V30.7528Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.8024H4V30.8519H7.91208V30.8024Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.8519H4V30.9015H7.91208V30.8519Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.9015H4V30.9511H7.91208V30.9015Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 30.9511H4V31.0007H7.91208V30.9511Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.0007H4V31.0502H7.91208V31.0007Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.0502H4V31.0998H7.91208V31.0502Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.0998H4V31.1494H7.91208V31.0998Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.1494H4V31.1989H7.91208V31.1494Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.1989H4V31.2485H7.91208V31.1989Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.2485H4V31.2981H7.91208V31.2485Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.2974H4V31.347H7.91208V31.2974Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.347H4V31.3966H7.91208V31.347Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.3966H4V31.4461H7.91208V31.3966Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.4461H4V31.4957H7.91208V31.4461Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.4957H4V31.5453H7.91208V31.4957Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.5453H4V31.5948H7.91208V31.5453Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.5948H4V31.6444H7.91208V31.5948Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.6444H4V31.694H7.91208V31.6444Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.694H4V31.7436H7.91208V31.694Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.7436H4V31.7931H7.91208V31.7436Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.7931H4V31.8427H7.91208V31.7931Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.8427H4V31.8923H7.91208V31.8427Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.8923H4V31.9418H7.91208V31.8923Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.9418H4V31.9914H7.91208V31.9418Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 31.9914H4V32.041H7.91208V31.9914Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.041H4V32.0906H7.91208V32.041Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.0906H4V32.1401H7.91208V32.0906Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.1401H4V32.1897H7.91208V32.1401Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.1897H4V32.2393H7.91208V32.1897Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.2386H4V32.2882H7.91208V32.2386Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.2882H4V32.3377H7.91208V32.2882Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.3377H4V32.3873H7.91208V32.3377Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.3873H4V32.4369H7.91208V32.3873Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.4369H4V32.4865H7.91208V32.4369Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.4865H4V32.536H7.91208V32.4865Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.536H4V32.5856H7.91208V32.536Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.5856H4V32.6352H7.91208V32.5856Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.6352H4V32.6848H7.91208V32.6352Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.6848H4V32.7343H7.91208V32.6848Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.7343H4V32.7839H7.91208V32.7343Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.7839H4V32.8335H7.91208V32.7839Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.8335H4V32.883H7.91208V32.8335Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.883H4V32.9326H7.91208V32.883Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.9326H4V32.9822H7.91208V32.9326Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 32.9822H4V33.0318H7.91208V32.9822Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.0318H4V33.0813H7.91208V33.0318Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.0813H4V33.1309H7.91208V33.0813Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.1309H4V33.1805H7.91208V33.1309Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.1798H4V33.2294H7.91208V33.1798Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.2294H4V33.2789H7.91208V33.2294Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.2789H4V33.3285H7.91208V33.2789Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.3285H4V33.3781H7.91208V33.3285Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.3781H4V33.4277H7.91208V33.3781Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.4277H4V33.4772H7.91208V33.4277Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.4772H4V33.5268H7.91208V33.4772Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.5268H4V33.5764H7.91208V33.5268Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.5764H4V33.6259H7.91208V33.5764Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.6259H4V33.6755H7.91208V33.6259Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.6755H4V33.7251H7.91208V33.6755Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.7251H4V33.7747H7.91208V33.7251Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.7747H4V33.8242H7.91208V33.7747Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.8242H4V33.8738H7.91208V33.8242Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.8738H4V33.9234H7.91208V33.8738Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.9234H4V33.973H7.91208V33.9234Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 33.973H4V34.0225H7.91208V33.973Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.0225H4V34.0721H7.91208V34.0225Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.0714H4V34.121H7.91208V34.0714Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.121H4V34.1706H7.91208V34.121Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.1706H4V34.2201H7.91208V34.1706Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.2201H4V34.2697H7.91208V34.2201Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.2697H4V34.3193H7.91208V34.2697Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.3193H4V34.3689H7.91208V34.3193Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.3689H4V34.4184H7.91208V34.3689Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.4184H4V34.468H7.91208V34.4184Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.468H4V34.5176H7.91208V34.468Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.5176H4V34.5671H7.91208V34.5176Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.5672H4V34.6167H7.91208V34.5672Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.6167H4V34.6663H7.91208V34.6167Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.6663H4V34.7159H7.91208V34.6663Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.7159H4V34.7654H7.91208V34.7159Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.7654H4V34.815H7.91208V34.7654Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.815H4V34.8646H7.91208V34.815Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.8646H4V34.9142H7.91208V34.8646Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.9142H4V34.9637H7.91208V34.9142Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 34.9637H4V35.0133H7.91208V34.9637Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.0126H4V35.0622H7.91208V35.0126Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.0622H4V35.1118H7.91208V35.0622Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.1118H4V35.1613H7.91208V35.1118Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.1613H4V35.2109H7.91208V35.1613Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.2109H4V35.2605H7.91208V35.2109Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.2605H4V35.31H7.91208V35.2605Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.3101H4V35.3596H7.91208V35.3101Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.3596H4V35.4092H7.91208V35.3596Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.4092H4V35.4588H7.91208V35.4092Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.4588H4V35.5083H7.91208V35.4588Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.5083H4V35.5579H7.91208V35.5083Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.5579H4V35.6075H7.91208V35.5579Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.6075H4V35.6571H7.91208V35.6075Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.6571H4V35.7066H7.91208V35.6571Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.7066H4V35.7562H7.91208V35.7066Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.7562H4V35.8058H7.91208V35.7562Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.8058H4V35.8554H7.91208V35.8058Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.8553H4V35.9049H7.91208V35.8553Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.9049H4V35.9545H7.91208V35.9049Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 35.9538H4V36.0034H7.91208V35.9538Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.0034H4V36.053H7.91208V36.0034Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.053H4V36.1025H7.91208V36.053Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.1025H4V36.1521H7.91208V36.1025Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.1521H4V36.2017H7.91208V36.1521Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.2017H4V36.2512H7.91208V36.2017Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.2512H4V36.3008H7.91208V36.2512Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.3008H4V36.3504H7.91208V36.3008Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.3504H4V36.4H7.91208V36.3504Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.4H4V36.4495H7.91208V36.4Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.4495H4V36.4991H7.91208V36.4495Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.4991H4V36.5487H7.91208V36.4991Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.5487H4V36.5983H7.91208V36.5487Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.5983H4V36.6478H7.91208V36.5983Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.6478H4V36.6974H7.91208V36.6478Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.6974H4V36.747H7.91208V36.6974Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.747H4V36.7966H7.91208V36.747Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.7966H4V36.8461H7.91208V36.7966Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.8454H4V36.895H7.91208V36.8454Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.895H4V36.9446H7.91208V36.895Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.9446H4V36.9942H7.91208V36.9446Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 36.9941H4V37.0437H7.91208V36.9941Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.0437H4V37.0933H7.91208V37.0437Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.0933H4V37.1429H7.91208V37.0933Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.1429H4V37.1924H7.91208V37.1429Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.1924H4V37.242H7.91208V37.1924Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.242H4V37.2916H7.91208V37.242Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.2916H4V37.3412H7.91208V37.2916Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.3412H4V37.3907H7.91208V37.3412Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.3907H4V37.4403H7.91208V37.3907Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.4403H4V37.4899H7.91208V37.4403Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.4899H4V37.5395H7.91208V37.4899Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.5395H4V37.589H7.91208V37.5395Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.589H4V37.6386H7.91208V37.589Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.6386H4V37.6882H7.91208V37.6386Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.6882H4V37.7377H7.91208V37.6882Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.7377H4V37.7873H7.91208V37.7377Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.7866H4V37.8362H7.91208V37.7866Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.8362H4V37.8858H7.91208V37.8362Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.8858H4V37.9353H7.91208V37.8858Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.9353H4V37.9849H7.91208V37.9353Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 37.9849H4V38.0345H7.91208V37.9849Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.0345H4V38.0841H7.91208V38.0345Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.0841H4V38.1336H7.91208V38.0841Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.1336H4V38.1832H7.91208V38.1336Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.1832H4V38.2328H7.91208V38.1832Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.2328H4V38.2824H7.91208V38.2328Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.2824H4V38.3319H7.91208V38.2824Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.3319H4V38.3815H7.91208V38.3319Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.3815H4V38.4311H7.91208V38.3815Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.4311H4V38.4806H7.91208V38.4311Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.4807H4V38.5302H7.91208V38.4807Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.5302H4V38.5798H7.91208V38.5302Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.5798H4V38.6294H7.91208V38.5798Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.6294H4V38.6789H7.91208V38.6294Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.6789H4V38.7285H7.91208V38.6789Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.7278H4V38.7774H7.91208V38.7278Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.7774H4V38.827H7.91208V38.7774Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.827H4V38.8765H7.91208V38.827Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.8765H4V38.9261H7.91208V38.8765Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.9261H4V38.9757H7.91208V38.9261Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 38.9757H4V39.0253H7.91208V38.9757Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 39.0253H4V39.0748H7.91208V39.0253Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 39.0748H4V39.1244H7.91208V39.0748Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 39.1244H4V39.174H7.91208V39.1244Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 39.174H4V39.2236H7.91208V39.174Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91208 39.2236H4V39.2325H7.91208V39.2236Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_120_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 27,
    width: 5,
    height: 13
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53493 33.7471C8.53493 31.5721 8.53493 29.6842 8.53493 27.7963C8.53493 27.6689 8.52051 27.6772 8.65647 27.6772C9.12274 27.6772 9.589 27.6772 10.0553 27.6772C10.0772 27.6772 10.0985 27.6779 10.1205 27.6772C10.1583 27.6751 10.1796 27.6896 10.1775 27.7309C10.1761 27.7529 10.1775 27.7743 10.1775 27.7963C10.1775 31.0179 10.1775 34.2401 10.1775 37.4617C10.1775 37.5456 10.2203 37.5876 10.3059 37.5876C10.9775 37.5876 11.6491 37.5876 12.32 37.5876C12.4511 37.5876 12.4346 37.5863 12.4353 37.7047C12.4353 38.1722 12.4353 38.6397 12.4353 39.1065C12.4353 39.1251 12.434 39.1437 12.4353 39.1623C12.4381 39.2063 12.4182 39.2256 12.3749 39.2229C12.3529 39.2215 12.3316 39.2229 12.3097 39.2229C11.6415 39.2229 10.9727 39.2098 10.3045 39.227C9.75449 39.2415 9.20514 39.2304 8.65579 39.2387C8.63381 39.2387 8.61252 39.2373 8.59055 39.2387C8.54798 39.2415 8.52531 39.2256 8.52875 39.1802C8.53012 39.1643 8.52875 39.1492 8.52875 39.1334C8.52875 38.6411 8.52531 38.1488 8.52875 37.6565C8.54111 36.2574 8.52875 34.8584 8.53355 33.7464L8.53493 33.7471Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_120_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 27.6689H8.52051V27.6772H12.4511V27.6689Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 27.6765H8.52051V27.7392H12.4511V27.6765Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 27.7399H8.52051V27.8025H12.4511V27.7399Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 27.8025H8.52051V27.8652H12.4511V27.8025Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 27.8652H8.52051V27.9278H12.4511V27.8652Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 27.9278H8.52051V27.9905H12.4511V27.9278Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 27.9912H8.52051V28.0538H12.4511V27.9912Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.0538H8.52051V28.1165H12.4511V28.0538Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.1165H8.52051V28.1791H12.4511V28.1165Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.1791H8.52051V28.2418H12.4511V28.1791Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.2425H8.52051V28.3051H12.4511V28.2425Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.3051H8.52051V28.3678H12.4511V28.3051Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.3678H8.52051V28.4304H12.4511V28.3678Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.4311H8.52051V28.4938H12.4511V28.4311Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.4938H8.52051V28.5564H12.4511V28.4938Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.5564H8.52051V28.6191H12.4511V28.5564Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.6191H8.52051V28.6817H12.4511V28.6191Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.6824H8.52051V28.7451H12.4511V28.6824Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.7451H8.52051V28.8077H12.4511V28.7451Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.8077H8.52051V28.8704H12.4511V28.8077Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.8704H8.52051V28.933H12.4511V28.8704Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.9337H8.52051V28.9964H12.4511V28.9337Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 28.9964H8.52051V29.059H12.4511V28.9964Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.059H8.52051V29.1217H12.4511V29.059Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.1224H8.52051V29.185H12.4511V29.1224Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.1851H8.52051V29.2477H12.4511V29.1851Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.2477H8.52051V29.3104H12.4511V29.2477Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.3103H8.52051V29.373H12.4511V29.3103Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.3737H8.52051V29.4364H12.4511V29.3737Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.4364H8.52051V29.499H12.4511V29.4364Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.499H8.52051V29.5617H12.4511V29.499Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.5617H8.52051V29.6243H12.4511V29.5617Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.625H8.52051V29.6877H12.4511V29.625Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.6877H8.52051V29.7503H12.4511V29.6877Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.7503H8.52051V29.813H12.4511V29.7503Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.8137H8.52051V29.8763H12.4511V29.8137Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.8763H8.52051V29.939H12.4511V29.8763Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 29.939H8.52051V30.0016H12.4511V29.939Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.0016H8.52051V30.0643H12.4511V30.0016Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.065H8.52051V30.1276H12.4511V30.065Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.1276H8.52051V30.1903H12.4511V30.1276Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.1903H8.52051V30.2529H12.4511V30.1903Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.2529H8.52051V30.3156H12.4511V30.2529Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.3163H8.52051V30.3789H12.4511V30.3163Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.3789H8.52051V30.4416H12.4511V30.3789Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.4416H8.52051V30.5042H12.4511V30.4416Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.5049H8.52051V30.5676H12.4511V30.5049Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.5676H8.52051V30.6302H12.4511V30.5676Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.6302H8.52051V30.6929H12.4511V30.6302Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.6929H8.52051V30.7555H12.4511V30.6929Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.7562H8.52051V30.8189H12.4511V30.7562Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.8189H8.52051V30.8815H12.4511V30.8189Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.8815H8.52051V30.9442H12.4511V30.8815Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 30.9442H8.52051V31.0069H12.4511V30.9442Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.0075H8.52051V31.0702H12.4511V31.0075Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.0702H8.52051V31.1328H12.4511V31.0702Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.1328H8.52051V31.1955H12.4511V31.1328Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.1962H8.52051V31.2588H12.4511V31.1962Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.2588H8.52051V31.3215H12.4511V31.2588Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.3215H8.52051V31.3841H12.4511V31.3215Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.3842H8.52051V31.4468H12.4511V31.3842Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.4475H8.52051V31.5101H12.4511V31.4475Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.5101H8.52051V31.5728H12.4511V31.5101Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.5728H8.52051V31.6355H12.4511V31.5728Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.6355H8.52051V31.6981H12.4511V31.6355Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.6988H8.52051V31.7615H12.4511V31.6988Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.7615H8.52051V31.8241H12.4511V31.7615Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.8241H8.52051V31.8868H12.4511V31.8241Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.8875H8.52051V31.9501H12.4511V31.8875Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 31.9501H8.52051V32.0128H12.4511V31.9501Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.0128H8.52051V32.0754H12.4511V32.0128Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.0754H8.52051V32.1381H12.4511V32.0754Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.1388H8.52051V32.2014H12.4511V32.1388Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.2014H8.52051V32.2641H12.4511V32.2014Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.2641H8.52051V32.3267H12.4511V32.2641Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.3267H8.52051V32.3894H12.4511V32.3267Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.3901H8.52051V32.4527H12.4511V32.3901Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.4527H8.52051V32.5154H12.4511V32.4527Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.5154H8.52051V32.578H12.4511V32.5154Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.5787H8.52051V32.6414H12.4511V32.5787Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.6414H8.52051V32.704H12.4511V32.6414Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.704H8.52051V32.7667H12.4511V32.704Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.7667H8.52051V32.8293H12.4511V32.7667Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.83H8.52051V32.8927H12.4511V32.83Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.8927H8.52051V32.9553H12.4511V32.8927Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 32.9553H8.52051V33.018H12.4511V32.9553Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.018H8.52051V33.0806H12.4511V33.018Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.0813H8.52051V33.144H12.4511V33.0813Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.144H8.52051V33.2067H12.4511V33.144Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.2066H8.52051V33.2693H12.4511V33.2066Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.27H8.52051V33.3326H12.4511V33.27Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.3326H8.52051V33.3953H12.4511V33.3326Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.3953H8.52051V33.458H12.4511V33.3953Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.458H8.52051V33.5206H12.4511V33.458Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.5213H8.52051V33.5839H12.4511V33.5213Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.584H8.52051V33.6466H12.4511V33.584Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.6466H8.52051V33.7093H12.4511V33.6466Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.7093H8.52051V33.7719H12.4511V33.7093Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.7726H8.52051V33.8353H12.4511V33.7726Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.8353H8.52051V33.8979H12.4511V33.8353Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.8979H8.52051V33.9606H12.4511V33.8979Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 33.9613H8.52051V34.0239H12.4511V33.9613Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.0239H8.52051V34.0866H12.4511V34.0239Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.0866H8.52051V34.1492H12.4511V34.0866Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.1492H8.52051V34.2119H12.4511V34.1492Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.2126H8.52051V34.2752H12.4511V34.2126Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.2752H8.52051V34.3379H12.4511V34.2752Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.3379H8.52051V34.4005H12.4511V34.3379Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.4005H8.52051V34.4632H12.4511V34.4005Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.4639H8.52051V34.5265H12.4511V34.4639Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.5265H8.52051V34.5892H12.4511V34.5265Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.5892H8.52051V34.6518H12.4511V34.5892Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.6518H8.52051V34.7145H12.4511V34.6518Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.7152H8.52051V34.7778H12.4511V34.7152Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.7778H8.52051V34.8405H12.4511V34.7778Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.8405H8.52051V34.9031H12.4511V34.8405Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.9038H8.52051V34.9665H12.4511V34.9038Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 34.9665H8.52051V35.0291H12.4511V34.9665Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.0291H8.52051V35.0918H12.4511V35.0291Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.0918H8.52051V35.1544H12.4511V35.0918Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.1551H8.52051V35.2178H12.4511V35.1551Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.2178H8.52051V35.2804H12.4511V35.2178Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.2804H8.52051V35.3431H12.4511V35.2804Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.3431H8.52051V35.4058H12.4511V35.3431Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.4064H8.52051V35.4691H12.4511V35.4064Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.4691H8.52051V35.5318H12.4511V35.4691Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.5317H8.52051V35.5944H12.4511V35.5317Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.5951H8.52051V35.6577H12.4511V35.5951Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.6578H8.52051V35.7204H12.4511V35.6578Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.7204H8.52051V35.7831H12.4511V35.7204Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.7831H8.52051V35.8457H12.4511V35.7831Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.8464H8.52051V35.9091H12.4511V35.8464Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.909H8.52051V35.9717H12.4511V35.909Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 35.9717H8.52051V36.0344H12.4511V35.9717Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.0344H8.52051V36.097H12.4511V36.0344Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.0977H8.52051V36.1604H12.4511V36.0977Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.1604H8.52051V36.223H12.4511V36.1604Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.223H8.52051V36.2857H12.4511V36.223Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.2864H8.52051V36.349H12.4511V36.2864Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.349H8.52051V36.4117H12.4511V36.349Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.4117H8.52051V36.4743H12.4511V36.4117Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.4743H8.52051V36.537H12.4511V36.4743Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.5377H8.52051V36.6003H12.4511V36.5377Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.6003H8.52051V36.663H12.4511V36.6003Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.663H8.52051V36.7256H12.4511V36.663Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.7256H8.52051V36.7883H12.4511V36.7256Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.789H8.52051V36.8516H12.4511V36.789Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.8516H8.52051V36.9143H12.4511V36.8516Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.9143H8.52051V36.9769H12.4511V36.9143Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 36.9776H8.52051V37.0403H12.4511V36.9776Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.0403H8.52051V37.1029H12.4511V37.0403Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.1029H8.52051V37.1656H12.4511V37.1029Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.1656H8.52051V37.2283H12.4511V37.1656Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.2289H8.52051V37.2916H12.4511V37.2289Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.2916H8.52051V37.3542H12.4511V37.2916Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.3542H8.52051V37.4169H12.4511V37.3542Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.4169H8.52051V37.4796H12.4511V37.4169Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.4802H8.52051V37.5429H12.4511V37.4802Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.5429H8.52051V37.6055H12.4511V37.5429Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.6056H8.52051V37.6682H12.4511V37.6056Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.6689H8.52051V37.7316H12.4511V37.6689Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.7315H8.52051V37.7942H12.4511V37.7315Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.7942H8.52051V37.8569H12.4511V37.7942Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.8569H8.52051V37.9195H12.4511V37.8569Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.9202H8.52051V37.9829H12.4511V37.9202Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 37.9829H8.52051V38.0455H12.4511V37.9829Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.0455H8.52051V38.1082H12.4511V38.0455Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.1082H8.52051V38.1708H12.4511V38.1082Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.1715H8.52051V38.2342H12.4511V38.1715Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.2342H8.52051V38.2968H12.4511V38.2342Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.2968H8.52051V38.3595H12.4511V38.2968Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.3602H8.52051V38.4228H12.4511V38.3602Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.4228H8.52051V38.4855H12.4511V38.4228Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.4855H8.52051V38.5481H12.4511V38.4855Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.5481H8.52051V38.6108H12.4511V38.5481Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.6115H8.52051V38.6741H12.4511V38.6115Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.6741H8.52051V38.7368H12.4511V38.6741Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.7368H8.52051V38.7994H12.4511V38.7368Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.7994H8.52051V38.8621H12.4511V38.7994Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.8628H8.52051V38.9254H12.4511V38.8628Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.9254H8.52051V38.9881H12.4511V38.9254Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 38.9881H8.52051V39.0507H12.4511V38.9881Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 39.0514H8.52051V39.1141H12.4511V39.0514Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 39.1141H8.52051V39.1767H12.4511V39.1141Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 39.1767H8.52051V39.2394H12.4511V39.1767Z",
    fill: "#C8AD49"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9541 35.7465L49.4408 34.3935H45.0683L44.555 35.7766C44.3543 36.3162 44.1835 36.6804 44.0417 36.8693C43.8999 37.0581 43.6671 37.1525 43.3452 37.1525C43.071 37.1525 42.8288 37.0519 42.6187 36.8506C42.4087 36.6493 42.3031 36.422 42.3031 36.1668C42.3031 36.0194 42.3279 35.8679 42.3766 35.7102C42.4252 35.5535 42.5059 35.3346 42.6187 35.0555L45.3695 28.0524C45.4481 27.8511 45.5423 27.6104 45.652 27.3282C45.7617 27.0459 45.8797 26.8125 46.0039 26.6257C46.1281 26.4389 46.2926 26.2885 46.4955 26.1733C46.6983 26.0581 46.9487 26 47.2478 26C47.5469 26 47.8046 26.0581 48.0074 26.1733C48.2103 26.2885 48.3738 26.4368 48.499 26.6184C48.6242 26.8 48.7288 26.9951 48.8147 27.2037C48.9006 27.4122 49.0092 27.6903 49.1406 28.039L51.9504 34.9974C52.1708 35.5266 52.2805 35.9115 52.2805 36.1523C52.2805 36.393 52.177 36.6316 51.969 36.8402C51.761 37.0488 51.5106 37.1525 51.2166 37.1525C51.0459 37.1525 50.8989 37.1214 50.7768 37.0602C50.6547 36.999 50.5522 36.916 50.4684 36.8101C50.3856 36.7043 50.2956 36.5424 50.2004 36.3245C50.1052 36.1066 50.0234 35.9136 49.9551 35.7476L49.9541 35.7465ZM45.6406 32.753H48.854L47.2323 28.3025L45.6406 32.753Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6071 27.324V35.1727H62.023C62.3749 35.1727 62.645 35.2589 62.8333 35.4301C63.0217 35.6013 63.1158 35.8171 63.1158 36.0776C63.1158 36.338 63.0227 36.5569 62.8375 36.7209C62.6512 36.8848 62.38 36.9678 62.023 36.9678H56.7626C56.2886 36.9678 55.9471 36.862 55.7391 36.6514C55.5311 36.4407 55.4276 36.0993 55.4276 35.6293V27.3251C55.4276 26.8841 55.527 26.5531 55.7246 26.3321C55.9223 26.111 56.1831 26.001 56.506 26.001C56.8289 26.001 57.099 26.11 57.3018 26.3289C57.5046 26.5468 57.6061 26.8799 57.6061 27.3261L57.6071 27.324Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0665 32.3555H68.3038V35.8202C68.3038 36.2768 68.2034 36.6119 68.0027 36.8278C67.8019 37.0436 67.5401 37.1515 67.2182 37.1515C66.8705 37.1515 66.6025 37.0384 66.411 36.8132C66.2206 36.5881 66.1254 36.2571 66.1254 35.8202V27.5233C66.1254 27.0522 66.2309 26.7118 66.441 26.5012C66.6511 26.2905 66.9916 26.1847 67.4604 26.1847H71.0039C71.4923 26.1847 71.9115 26.2055 72.2582 26.247C72.6059 26.2885 72.9184 26.3736 73.1968 26.5012C73.5342 26.6433 73.8322 26.8467 74.092 27.1113C74.3507 27.3759 74.5484 27.6841 74.6829 28.0348C74.8174 28.3855 74.8847 28.757 74.8847 29.1492C74.8847 29.9534 74.6581 30.5957 74.2058 31.0761C73.7536 31.5566 73.0674 31.8979 72.1485 32.0982C72.5345 32.3047 72.9039 32.6087 73.2558 33.0103C73.6077 33.4129 73.9223 33.8404 74.1986 34.2938C74.4749 34.7473 74.6902 35.1572 74.8444 35.5224C74.9986 35.8877 75.0751 36.1388 75.0751 36.2768C75.0751 36.4148 75.0296 36.56 74.9396 36.6991C74.8485 36.8392 74.7253 36.9492 74.5691 37.0301C74.4128 37.111 74.2317 37.1515 74.0258 37.1515C73.7815 37.1515 73.5756 37.0934 73.409 36.9782C73.2423 36.863 73.0995 36.7167 72.9795 36.5403C72.8594 36.3639 72.6969 36.1035 72.492 35.7611L71.6186 34.3042C71.306 33.7698 71.0256 33.3631 70.7783 33.0829C70.5309 32.8038 70.2805 32.6118 70.0259 32.5091C69.7713 32.4064 69.4515 32.3545 69.0645 32.3545L69.0665 32.3555ZM70.3136 27.8242H68.3038V30.7887H70.2556C70.7793 30.7887 71.2191 30.743 71.5762 30.6528C71.9332 30.5625 72.2054 30.4079 72.3937 30.1889C72.5821 29.971 72.6762 29.6701 72.6762 29.2883C72.6762 28.9894 72.6007 28.7259 72.4486 28.4976C72.2964 28.2693 72.0864 28.0991 71.8173 27.986C71.5627 27.8781 71.0618 27.8242 70.3136 27.8242Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6258 35.8202V27.324C78.6258 26.883 78.7262 26.552 78.927 26.331C79.1277 26.11 79.3864 26 79.7042 26C80.0219 26 80.2972 26.109 80.5 26.3279C80.7028 26.5458 80.8043 26.8789 80.8043 27.3251V35.8212C80.8043 36.2674 80.7028 36.6016 80.5 36.8215C80.2972 37.0426 80.0312 37.1525 79.7042 37.1525C79.3771 37.1525 79.1329 37.0405 78.9301 36.8174C78.7272 36.5943 78.6258 36.2622 78.6258 35.8212V35.8202Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.232 35.8202V32.4002L84.6054 28.3181C84.3757 27.9508 84.2132 27.6633 84.118 27.4579C84.0228 27.2524 83.9752 27.0729 83.9752 26.9214C83.9752 26.6714 84.0714 26.4555 84.2649 26.2739C84.4585 26.0923 84.6965 26.0021 84.98 26.0021C85.2781 26.0021 85.5047 26.0872 85.6589 26.2563C85.8131 26.4254 86.0439 26.7627 86.3523 27.268L88.3621 30.5407L90.3946 27.268C90.5167 27.0667 90.6192 26.8976 90.703 26.7606C90.7858 26.6236 90.8779 26.495 90.9783 26.3746C91.0787 26.2542 91.1894 26.1629 91.3126 26.0986C91.4347 26.0353 91.5837 26.0031 91.7596 26.0031C92.0339 26.0031 92.2626 26.0923 92.4458 26.2719C92.6289 26.4514 92.7211 26.6579 92.7211 26.8934C92.7211 27.0843 92.6745 27.2763 92.5813 27.4672C92.4882 27.6581 92.3299 27.9227 92.1043 28.2621L89.4115 32.4033V35.8233C89.4115 36.2695 89.309 36.6036 89.1031 36.8236C88.8971 37.0446 88.6363 37.1546 88.3186 37.1546C88.0009 37.1546 87.7339 37.0457 87.5331 36.8267C87.3324 36.6088 87.232 36.2737 87.232 35.8223V35.8202Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.752 35.7465L101.238 34.3935H96.8658L96.3525 35.7766C96.1517 36.3162 95.9809 36.6804 95.8392 36.8693C95.6974 37.0581 95.4645 37.1525 95.1427 37.1525C94.8684 37.1525 94.6263 37.0519 94.4162 36.8506C94.2061 36.6493 94.1005 36.422 94.1005 36.1668C94.1005 36.0194 94.1254 35.8679 94.174 35.7102C94.2227 35.5535 94.3034 35.3346 94.4162 35.0555L97.1669 28.0524C97.2456 27.8511 97.3398 27.6104 97.4495 27.3282C97.5592 27.0459 97.6771 26.8125 97.8013 26.6257C97.9255 26.4389 98.09 26.2885 98.2929 26.1733C98.4957 26.0581 98.7462 26 99.0453 26C99.3443 26 99.602 26.0581 99.8049 26.1733C100.008 26.2885 100.171 26.4368 100.296 26.6184C100.422 26.8 100.526 26.9951 100.612 27.2037C100.698 27.4122 100.807 27.6903 100.938 28.039L103.748 34.9974C103.968 35.5266 104.078 35.9115 104.078 36.1523C104.078 36.393 103.974 36.6316 103.766 36.8402C103.558 37.0488 103.308 37.1525 103.014 37.1525C102.843 37.1525 102.696 37.1214 102.574 37.0602C102.452 36.999 102.35 36.916 102.266 36.8101C102.183 36.7043 102.093 36.5424 101.998 36.3245C101.903 36.1066 101.821 35.9136 101.753 35.7476L101.752 35.7465ZM97.4381 32.753H100.651L99.0297 28.3025L97.4381 32.753Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.619 26.1837H111.458C112.197 26.1837 112.83 26.2521 113.358 26.3902C113.886 26.5282 114.366 26.7845 114.795 27.1622C115.915 28.123 116.475 29.585 116.475 31.5462C116.475 32.1937 116.419 32.7841 116.306 33.3185C116.194 33.8528 116.021 34.3343 115.786 34.7639C115.551 35.1935 115.251 35.5764 114.883 35.9146C114.595 36.1751 114.279 36.3826 113.937 36.5403C113.595 36.697 113.226 36.808 112.833 36.8713C112.44 36.9357 111.996 36.9668 111.501 36.9668H108.663C108.266 36.9668 107.968 36.9066 107.767 36.7863C107.567 36.6659 107.436 36.4968 107.375 36.2788C107.314 36.0609 107.283 35.7777 107.283 35.429V27.5212C107.283 27.0501 107.389 26.7097 107.599 26.4991C107.809 26.2885 108.149 26.1826 108.618 26.1826L108.619 26.1837ZM109.463 27.9124V35.2308H111.113C111.475 35.2308 111.759 35.2215 111.964 35.2018C112.169 35.1821 112.382 35.1333 112.602 35.0544C112.823 34.9756 113.013 34.8656 113.175 34.7234C113.903 34.106 114.268 33.0414 114.268 31.5306C114.268 30.467 114.107 29.6701 113.787 29.1399C113.467 28.6107 113.072 28.2735 112.602 28.1282C112.133 27.984 111.565 27.9113 110.9 27.9113H109.463V27.9124Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.292 35.7465L125.779 34.3935H121.406L120.893 35.7766C120.692 36.3162 120.522 36.6804 120.38 36.8693C120.238 37.0581 120.005 37.1525 119.683 37.1525C119.409 37.1525 119.167 37.0519 118.957 36.8506C118.747 36.6493 118.641 36.422 118.641 36.1668C118.641 36.0194 118.666 35.8679 118.715 35.7102C118.763 35.5535 118.844 35.3346 118.957 35.0555L121.708 28.0524C121.786 27.8511 121.88 27.6104 121.99 27.3282C122.1 27.0459 122.218 26.8125 122.342 26.6257C122.466 26.4389 122.631 26.2885 122.833 26.1733C123.036 26.0581 123.287 26 123.586 26C123.885 26 124.143 26.0581 124.345 26.1733C124.548 26.2885 124.712 26.4368 124.837 26.6184C124.962 26.8 125.067 26.9951 125.153 27.2037C125.239 27.4122 125.347 27.6903 125.479 28.039L128.288 34.9974C128.509 35.5266 128.619 35.9115 128.619 36.1523C128.619 36.393 128.515 36.6316 128.307 36.8402C128.099 37.0488 127.849 37.1525 127.555 37.1525C127.384 37.1525 127.237 37.1214 127.115 37.0602C126.993 36.999 126.89 36.916 126.806 36.8101C126.724 36.7043 126.634 36.5424 126.538 36.3245C126.443 36.1066 126.361 35.9136 126.293 35.7476L126.292 35.7465ZM121.979 32.753H125.192L123.57 28.3025L121.979 32.753Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo-2.df85c623010431a8f601a5e4ed5667e0.svg";
export { ForwardRef as ReactComponent };